import { Component, OnInit, Input, Output, EventEmitter, ViewChild, Inject, ElementRef, Renderer2 } from '@angular/core';
import { MessageService, MenuItem, LazyLoadEvent } from 'primeng/api';
import { RiderService, DeliveryOrderService, AppDataService, XpressUserService, VehicleBrandService, RiderActivityHistoryService } from 'app/services';
import { drawRiderHistoryRouteOnMap, toRiderHistoryPoints } from '@shared/rider-activity-history/rider-activity-history';
import { Utils } from 'app/utils';
import {
    XpressDeliveryStatus,
    RiderVehicleTypeEnum,
    UserWalletOperationTypeEnum,
    XpressUserRoleEnum,
    GenderModel,
    ServiceTypeEnum,
    DriverAwardType,
    BetaFeature,
    RiderServiceTypeModel,
    RiderVehicleType, DriverCampaignType, MenuPermissionConfig, Xpress50IncentiveType, BookingStatus,
	WalletCommerceTransactions,
	DriverTypeEnum,
	VehicleBrandModel,
	VehicleModel
} from 'app/models';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { PaymentProcessingService } from 'app/services/payment-processing.service';
import { AppComponent, RootEnum } from 'app/app.component';
import { FontColorStatus, StylesStatus } from 'app/models/users/StylesStatus';
import { StylesPerfCard } from 'app/models/users/StylesPerfCard';
import { XpressCalendarEnum } from 'app/xpress-calendar/xpress-calendar.enum';
import { ExportFileTypeModel } from 'app/models';
import { RidesharingAppModel } from 'app/models/rider/ridesharing-app.model';
import { FinanceMenuEnum } from 'app/finance';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { TableLazyLoadEvent } from 'primeng/table';
import { WALLET_TRANSACTIONS, walletTransactions } from './driver-commerce/products-availed';
import { ProvideTestId, TEST_ID_TOKEN } from 'app/providers';
import { MenuPermissionActionEnum } from 'app/models/enums/menu/menu-permission-action.enum';
import { ConfirmationDialogService } from '@shared/services/confirmation-dialog.service';
import { XpressDocumentTypeEnum } from '@shared/enums/xpress-document-type.enum';
import { XpressRiderDocumentVerificationStatusEnum } from '@shared/enums/xpress-rider-document-verification-status.enum';
import { ColorTypeSelection } from 'app/models/color-type.selection';
import { SignupParams } from 'app/components/operator/operator-signup/signup-params';

enum MenuTab {
    DriverInfo = 1,
    LegalDocument = 2,
    Vehicles = 3,
    Commerce = 4,
    Orders = 5,
    DriverStats = 6,
    Finances = 7,
    History = 8,
    Disciplinary = 9,
    Chat = 10,
	Training = 11,
	RiderShiftLog = 12,
	OfflineSync = 13
}

enum MenuFinanceTab {
    Balance = 1,
    Payout = 2
}

enum AdjustWalletBalanceTypeEnum {
    None = 0,
    AdminAdjustment = 1,
    RxpDailyDeduction = 2,
    RxpGuaranteePay = 3,
    RxpOperatorsDailyDeduction = 4,
    GadgetDeductionInstallment = 5,
    GadgetDeductionRegular = 6,
    VehicleDeductionInstallment = 7,
	VehicleDeductionRegular = 8,
	DriverCommerceDailyDeduction = 9,
	XpressTopUp = 10,
	XpressDriverDepositTopUp = 11,
	AdminAdjustmentNineNine15KTopUp = 12,
	AdminAdjustment4KTopUp = 13,
	GeneralAdjustment = 14
}

enum LegalDocVerificationCheck {
    DriverLicense = 76,
    OrCr = 77,
    VehiclePhotos = 78,
    Nbi = 79,
    PaOrCpc = 80,
    PreviousAppExperience = 81,
    TinNumberProof = 87,
    PoliceClearance = 90,
}

type LegalDocStatus = 'Valid' | 'Approved' | 'Expiring' | 'Expired' | 'Action Required' | 'Rejected';
type LegalDocEditKey = 'licenseNumber' | 'licenseType' | 'licenseExpiry' | 'nbiValidUntil'
    | 'plate' | 'brandId' | 'modelId' | 'orCrExpiry' | 'color'
    | 'paCpcType' | 'paCpcCaseNumber' | 'paCpcExpiry' | 'ridesharingAppId'
    | 'tinNumber' | 'tinRegisteredName';

interface LegalDocFile {
    fileId?: number;
    name: string;
    imageUrl: string;
    safeUrl?: any;
    isPdf: boolean;
}

interface LegalDocDetailRow {
    label: string;
    value: string;
}

interface LegalDocEditField {
    key: LegalDocEditKey;
    label: string;
    type: 'text' | 'date' | 'license' | 'color' | 'brand' | 'model' | 'pacpc' | 'ridesharing';
}

interface LegalDocCard {
    key: string;
    group: string;
    title: string;
    uploadSource: string;
    required: boolean;
    uploadedBy: string;
    uploadedAt: string;
    checkType?: LegalDocVerificationCheck;
    status: LegalDocStatus;
    files: LegalDocFile[];
    detailRows: LegalDocDetailRow[];
    editFields: LegalDocEditField[];
    newFiles: File[];
    removedFileIds: number[];
    edit: { [key in LegalDocEditKey]?: any };
}

interface LegalDocGroup {
    title: string;
    cards: LegalDocCard[];
}

@Component({
    selector: 'driver-detail',
    templateUrl: './driver-detail.component.html',
    providers:[ProvideTestId('driver-detail')],
    styleUrls: ['./driver-detail.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss',
        '../../../../../styles/default-paginator.scss'
    ]
})
export class DriverDetailComponent implements OnInit {
    public visibleDetail: boolean = false;
    @Input()
    set _visibleDetail(value: boolean) {
        this.visibleDetail = value;
    }

    @Output() OnBackToDashboardHandle = new EventEmitter<any>();
    @Output() public showTransactions = new EventEmitter<number>();
    @Output() public showDetails = new EventEmitter<number>();

    public driverId!: number;
    @Input()
    set _driverId(value: number) {
        this.driverId = value;
        if (this.driverId > 0) {
            this.getRiderInfo();
        }
    }

    @Input() public isCommerceTab: boolean = false;
    @Input() public operatorEmbedded = false;
    private isViewInitialized = false;

    @Input()
    set embeddedTab(value: number | null) {
        if (value == null) {
            return;
        }
        this.activeTab = value as MenuTab;
        // Input setters run before ngOnInit, which assigns selectedDateRange.
        // Defer tab loads until after init so Bookings/Activity fetch with a real range.
        if (this.isViewInitialized && this.driverId > 0) {
            this.handleTabChange(value as MenuTab);
        }
    }

    @Input()
    public showEditFields: boolean = false;

    @Input()
    public showCampaignButton: boolean = false;

    @Input()
    public isActiveDrivers: boolean = false;

    public compensationProfile: any = null;
    public compensationProfileError: string | null = null;
    public isSalariedEarningType: boolean = false;
    public savedIsSalariedEarningType: boolean = false;
    public hasPendingEarningTypeChanges: boolean = false;
    public isEarningTypeLocked: boolean = false;
    public isEarningTypeUpdating: boolean = false;
    public earningTypeConfirmDialog: boolean = false;
    private hasSavedEarningTypeAssignment: boolean = false;

    @ViewChild('invitesDropdown')
    invitesDropdown: any;

    @ViewChild('campaignDropdown')
    campaignDropdown!: any;

    @ViewChild('chart')
    chart: any;

    @ViewChild('campaignsDropdown')
    campaignsDropdown!: any;

    @Input()
    public menuPermissionActive!: string;

    public driver: any = {};
    public initialDriver: any = {};
    public vehicles!: any;
    public riderWallet!: any;
    public riderTransactions!: any;
    public riderInvoices!: any;
    public riderStatistics!: any;
    public ratingPercentages: any[] = [];
    public monthYear: Date = new Date();
    public showAllComments: boolean = true;
    public statsMonthPicker: any = new Date(moment().startOf('month').toString());
    public customerFeedbackPercents: any[] = [];
    public userWalletOperationTypeEnum = UserWalletOperationTypeEnum;

    public genderList = GenderModel.GenderList;

    public partnerType: PartnerEnum = PartnerEnum.Gold;
    public driverCampaignList: any[] = [];
    public selectedCampaign!: any;
    public campaignName!: any;
    public xpress50IncentiveType = Xpress50IncentiveType; //Only for 4W
    public selectedXpress50IncentiveType: any; //Only for 4W
    public driverCampaignTypeEnum = DriverCampaignType;
    public selectedVehicle!: any;
    public isPartner: boolean = false; //todo later
    public avatarHover: boolean = false;
    public visibleCampaignDialog: boolean = false;
    public displayEditProfileDialog: boolean = false;
    public discardConfirmDialog: boolean = false;
    public removeDriver: boolean = false;
    public isSpinnerVisible: boolean = false;

    public isVehicleSpinner: boolean = false;
    public resetPasswordLoading: boolean = false;

    public invoiceId: number = 0;
    public isVisibleDisplayDriverPayoutInvoice: boolean = false;

    public showEditLegalDocuments: boolean = false;
    public uploadLegalDocumentsObj: any = {};

    public isPdfFile: boolean = false;
    public serviceTypes = (this.appData.isBoracayLocation) ? RiderServiceTypeModel.RiderServiceTypeBoracayList : RiderServiceTypeModel.RiderServiceTypeXpressList;
    public vehicleTypes = (this.appData.isBoracayLocation) ? RiderVehicleType.RiderVehicleTypeBoracayList : RiderVehicleType.RiderVehicleTypeXpressList;

    public driverAwardTypeEnum = DriverAwardType;

    public selectedDateRange: Date[] = [];

    public riderHistories: any[] = [];
    public riderPointHistory: any;

    adjustWalletBalanceAmount: number = 0;
    isRefundButtonDisabled: boolean = false;
    isRefundApplyButtonDisabled: boolean = false;
    showDialogRefundTransaction: boolean = false;
    adjustWalletBalanceIdempotencyKey: string = '';
    private isAdjustWalletBalanceInFlight: boolean = false;

    adjustWalletBalanceDescription: string | null = null;
    adjustWalletBalanceType = [
        {
            Id: 0,
            Name: 'None'
        },
        {
            Id: AdjustWalletBalanceTypeEnum.RxpDailyDeduction,
            Name: 'Admin Adjustment - RXP Daily Deduction'
        },
        {
            Id: AdjustWalletBalanceTypeEnum.RxpGuaranteePay,
            Name: 'Admin Adjustment - RXP Guarantee Pay'
        },
        {
            Id: AdjustWalletBalanceTypeEnum.RxpOperatorsDailyDeduction,
            Name: 'Admin Adjustment - RXP Operators Daily Deduction'
        },
        {
            Id: AdjustWalletBalanceTypeEnum.GadgetDeductionInstallment,
            Name: 'Admin Adjustment - Gadget Deduction - Installment'
        },
        {
            Id: AdjustWalletBalanceTypeEnum.GadgetDeductionRegular,
            Name: 'Admin Adjustment - Gadget Deduction - Regular'
        },
        {
            Id: AdjustWalletBalanceTypeEnum.VehicleDeductionInstallment,
            Name: 'Admin Adjustment - Vehicle Deduction - Installment'
        },
        {
            Id: AdjustWalletBalanceTypeEnum.VehicleDeductionRegular,
            Name: 'Admin Adjustment - Vehicle Deduction - Regular'
		},
		{
			Id: AdjustWalletBalanceTypeEnum.XpressDriverDepositTopUp,
			Name: 'Admin Adjustment - Xpress Driver Deposit TopUp'
		},
		{
			Id: AdjustWalletBalanceTypeEnum.AdminAdjustmentNineNine15KTopUp,
			Name: 'Admin Adjustment - 9.9 15K Top Up'
		},
		{
			Id: AdjustWalletBalanceTypeEnum.AdminAdjustment4KTopUp,
			Name: 'Admin Adjustment - 4K Top Up'
		},
		{
			Id: AdjustWalletBalanceTypeEnum.GeneralAdjustment,
			Name: 'Admin Adjustment - General Adjustment'
		},
		{
			Id: AdjustWalletBalanceTypeEnum.XpressTopUp,
			Name: 'Xpress Top Up'
		}
    ];
    selectedAdjustWalletBalanceType: { Id: number; Name: string } | null = this.adjustWalletBalanceType[0];
    readonly adjustWalletBalanceTypeEnum = AdjustWalletBalanceTypeEnum;

    isValidAmount: boolean = true;
    isPositiveAmountRequired: boolean = false;
    isNegativeAmountRequired: boolean = false;
    isDescriptionRequired: boolean = false;

    public canEditVehicles: boolean = false;
    public emailExist: boolean = false;
    public phoneExist: boolean = false;

    // Legal document editing persists through UpdateRiderInfoV2, which the API rejects for any
    // non-Admin role even when BackOffice.Drivers.Edit (canEditVehicles) is granted. Gate the
    // inline edit UI on Admin too, so non-admins don't see Edit/Save and hit an access-denied error.
    public get canEditLegalDocuments(): boolean {
        return this.canEditVehicles && +this.appData.authData.roleId === XpressUserRoleEnum.Admin;
    }

    // Prefer authData.roleId (set by AuthInitializer). xpressUserRoleId can stay
    // None on /operator refresh because AppComponent skips role setup there.
    public get isOperator(): boolean {
        return +this.appData.authData.roleId === XpressUserRoleEnum.Operator
            || this.appData.xpressUserRoleId === XpressUserRoleEnum.Operator;
    }

    // Operator accounts are identified by role only. Do not use OperatorId — admins can carry a
    // linked OperatorId from GetAuthData while viewing drivers in the admin portal.
    public get isOperatorAccount(): boolean {
        return +this.appData.authData.roleId === XpressUserRoleEnum.Operator;
    }

    private readonly operatorHiddenTabIds = new Set([
        String(MenuTab.Commerce),
        String(MenuTab.Finances),
        String(MenuTab.Chat),
        String(MenuTab.Training),
        String(MenuTab.Finances),
    ]);

    public visibleDriverUploadDoc: boolean = false;

    public orderMarkers: google.maps.Marker[] = [];
    public map!: google.maps.Map;
    public markerClusterer?: MarkerClusterer;
    public polylineRoutes: any[] = [];
    public walletCommerceTransactions: walletTransactions[] = WALLET_TRANSACTIONS;

    constructor(
        private messageService: MessageService,
        private riderService: RiderService,
        private deliveryOrderService: DeliveryOrderService,
        private userService: XpressUserService,
        public appData: AppDataService,
        public app: AppComponent,
        private sanitizer: DomSanitizer,
        protected elRef: ElementRef,
        protected renderer: Renderer2,
        private paymentProcessingService: PaymentProcessingService,
		private confirmationDialogService: ConfirmationDialogService,
        private vehicleBrandService: VehicleBrandService,
        private riderActivityHistory: RiderActivityHistoryService,
        @Inject(TEST_ID_TOKEN) public componentTestId: string
    ) {
    }

    @Output() changedVisibleDetailEmit = new EventEmitter<boolean>();
    changedVisibleDetail(increased: any) {
        this.changedVisibleDetailEmit.emit(increased);
    }

    //-------------------------Delivery Orders-------------------------
    // Stable column arrays so p-table [columns] / header *ngFor keep the same
    // identity across change detection (a getter that allocates anew each access
    // recreates headers and can reset sort UI).
    private readonly operatorOrderCols: any[] = [
        { field: 'Id', header: 'Transaction ID' },
        { field: 'DisplayFormatCreatedAt', header: 'Date & Time' },
        { field: 'StatusText', header: 'Status' },
        { field: 'VehicleTypeText', header: 'Vehicle Type' },
        { field: 'NumberPlate', header: 'Plate Number' },
    ];
    private readonly defaultOrderCols: any[] = [
        { field: 'Id', header: 'Transaction ID' },
        { field: 'DisplayFormatCreatedAt', header: 'Date & Time' },
        { field: 'StatusText', header: 'Status' },
        { field: 'PaymentMethod', header: 'Payment method' },
        { field: 'Amount', header: 'Customer Paid' },
        { field: 'DriverEarnings', header: 'Driver Earned' },
    ];
    public get orderCols(): any[] {
        return this.isOperator ? this.operatorOrderCols : this.defaultOrderCols;
    }
    public invoiceCols: any[] = [
        { field: 'InvoiceId', header: 'Invoice ID' },
        { field: 'Amount', header: 'Value' },
        { field: 'CreatedAt', header: 'Invoice Date' },
        { field: 'Status', header: 'Status' }
    ];
    public riderHistorietCols: any[] = [
        { field: 'Date', header: 'Date', width: '20%' },
        { field: 'FirstLogin', header: 'First Login', width: '20%' },
        { field: 'LastLogout', header: 'Last Logout', width: '20%' },
        { field: 'TotalActivity', header: 'Total Activity', width: '20%' },
        { field: 'TotalInactivity', header: 'Total Inactivity', width: '20%' },
        { field: 'Logins', header: 'Logins', width: '20%' },
        { field: 'Logouts', header: 'Logouts', width: '20%' }
    ];
    public trainingCols: any[] = [
        { field: 'Date', header: 'Date', width: '20%' },   //TODO after specs available
        { field: 'Type', header: 'Type', width: '20%' },
        { field: 'Trainer', header: 'Trainer', width: '20%' },
        { field: 'Assessor', header: 'Assessor', width: '20%' },
        { field: 'Time', header: 'Time', width: '20%' },
        { field: 'Result', header: 'Result', width: '20%' },
        { field: 'File', header: 'File', width: '20%' }
	];
	public shiftLogCols: any[] = [
		{ field: 'NumberPlate', header: 'Number Plate', width: '20%' },
		{ field: 'StartedAtDisplay', header: 'Started At', width: '20%' },
		{ field: 'EndedAtDisplay', header: 'Ended At', width: '20%' },
		{ field: 'IsTokenReceived', header: 'Token Received', width: '15%' },
		{ field: 'Actions', header: 'Actions', width: '25%' }
	];
    // Grid settings
    public rowsPerPage: number = 10;
    public rowsPerPageOptions: Array<number> = [50, 100, 500, 1000];
    public totalRecords: number = -1;
    public totalEarningsStr: string = '';

    public first: number = 0;
    public sortField: string | string[] = '';
    private sortOrder: number = 1;

    public driverOrders: Array<any> = [];
	public driverTrainings: Array<any> = [];

	public riderShiftLogs: Array<any> = [];
	public totalShiftLogRecords: number = 0;
	public firstShiftLog: number = 0;
	public isShiftLogSpinner: boolean = false;

	public unsyncedCols: any[] = [
		{ field: 'ClientReferenceId', header: 'Client Ref', width: '16%' },
		{ field: 'OrderIdDisplay', header: 'Order #', width: '8%' },
		{ field: 'StatusDisplay', header: 'Status', width: '9%' },
		{ field: 'AttemptCount', header: 'Attempts', width: '7%' },
		{ field: 'TotalFareDisplay', header: 'Total Fare', width: '10%' },
		{ field: 'CreatedAtDisplay', header: 'Created At', width: '14%' },
		{ field: 'LastAttemptAtDisplay', header: 'Last Attempt', width: '14%' },
		{ field: 'SyncError', header: 'Error', width: '12%' },
		{ field: 'Actions', header: 'Actions', width: '10%' }
	];
	public unsyncedOrders: Array<any> = [];
	public totalUnsyncedRecords: number = 0;
	public firstUnsynced: number = 0;
	public isUnsyncedSpinner: boolean = false;
	public totalUncollectedFare: number = 0;
	public totalFareAll: number = 0;
	public syncingId: number | null = null;
	public isSyncingAll: boolean = false;
	readonly driverTypeEnum = DriverTypeEnum;

    public showVehicleDetailsSidebar: boolean = false;
    public showVehicleDetailsInfo: boolean = false;
    public showEditVehicleModal: boolean = false;
    public activeHoursChartData: any;
    public activeHoursChartOptions: any;
    public filterObj: any = {};
    private searchTimer: number = 0;

    public filter: {
        searchName: string;
    } = { searchName: '' };
    public deliveryStatuses = XpressDeliveryStatus;
    public expressUserRoles = XpressUserRoleEnum;

    public selectedRiderVehicleTypes: RiderVehicleTypeEnum[] = [];
    public selectedDeliveryStatuses: XpressDeliveryStatus[] = [];
    public cancelRoleIds: XpressUserRoleEnum[] = [];

    public isOrderSpinner: boolean = true;
    //-----------------------------------------------------------------

    public menuFinanceTab = MenuFinanceTab;
    public activeMenuFinanceTab: MenuFinanceTab = MenuFinanceTab.Balance;

    public menuTab = MenuTab;
    public activeTab: MenuTab = MenuTab.DriverStats;
    public menuItems: MenuItem[] = [
        {
            id: String(MenuTab.DriverStats),
            label: 'Insights',
            command: (e: any) => this.handleTabChange(MenuTab.DriverStats)
        },
        {
            id: String(MenuTab.LegalDocument),
            label: 'Legal Docs',
            command: (e: any) => this.handleTabChange(MenuTab.LegalDocument)
        },
        {
            id: String(MenuTab.Vehicles),
            label: 'Vehicles',
            command: (e: any) => this.handleTabChange(MenuTab.Vehicles)
        },
        {
            id: String(MenuTab.Commerce),
            label: 'Commerce',
            command: (e: any) => this.handleTabChange(MenuTab.Commerce)
        },
        {
            id: String(MenuTab.Orders),
            label: 'Bookings',
            command: (e: any) => this.handleTabChange(MenuTab.Orders)
        },
    ];

    public additionalMenuItems: MenuItem[] = [
        {
            id: String(MenuTab.Disciplinary),
            label: 'Disciplinary', disabled: true,
            command: (e: any) => this.handleTabChange(MenuTab.Disciplinary)
        },
        {
            id: String(MenuTab.Finances),
            label: 'Wallet',
            command: (e: any) => this.handleTabChange(MenuTab.Finances)
        },
        {
            id: String(MenuTab.Chat),
            label: 'Chat', disabled: true,
            command: (e: any) => this.handleTabChange(MenuTab.Chat)
        },
        {
            id: String(MenuTab.History),
            label: 'App History',
            command: (e: any) => this.handleTabChange(MenuTab.History)
        },
        {
            id: String(MenuTab.Training),
            label: 'Training',
            command: (e: any) => this.handleTabChange(MenuTab.Training)
        }
	];

	public taxiMenuItems: MenuItem[] = [
		{
			id: String(MenuTab.RiderShiftLog),
			label: 'Rider Shift Log',
			command: (e: any) => this.handleTabChange(MenuTab.RiderShiftLog)
		},
		{
			id: String(MenuTab.OfflineSync),
			label: 'Unsynced Rides',
			command: (e: any) => this.handleTabChange(MenuTab.OfflineSync)
		}
	];

	get combinedMenuItems() {
		const allow = (m: MenuItem) =>
			!this.isOperatorAccount || !this.operatorHiddenTabIds.has(m.id ?? '');

		return [
			...this.menuItems.filter(allow),
			...this.additionalMenuItems.filter(allow),
			...(this.driver?.RiderType === DriverTypeEnum.Taxi || this.driver?.RiderType === DriverTypeEnum.Connex
				? this.taxiMenuItems : [])
		];
	}

	get activeMenuItem(): MenuItem {
		const items = this.combinedMenuItems;
		return items.find(m => m.id === String(this.activeTab)) ?? items[0];
	}

    public isVisibleDisplayOrderDetail: boolean = false;
    public orderId: number = 0;

    public isVisibleDriverTransactionDetail: boolean = false;
    public transactionDetail!: any;

    public isVisibleImageModal: boolean = false;
    public imageArray: string[] = [];

    public displayModalSuspend: boolean = false;
    public suspendUser: {
        userId: number | null;
        userName: string | null;
    } = { userId: null, userName: null };

    public showAddOrUpdateDisciplinarySideBar: boolean = false;
    public representativeFullName: string = '';

    public vehicleTypeList: any = [];
    public showExportSidebar: boolean = false;
    public showOrdersExportSidebar: boolean = false;
    public exportLoading: boolean = false;
    public exportData: any = {};

    ngOnInit(): void {
        this.renderer.setAttribute(this.elRef.nativeElement, 'data-testid', this.componentTestId);
        this.canEditVehicles = this.menuPermissionActive
            ? this.appData.hasPermission(this.menuPermissionActive, MenuPermissionActionEnum.Update)
            : (+this.appData.authData.roleId === XpressUserRoleEnum.Admin);

        const today = new Date();
        const tomorrow: Date = new Date(today.getTime() + (24 * 60 * 60 * 1000));
        const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
        this.selectedDateRange = [today, tomorrow];
        this.representativeFullName = this.appData.authData.userName;
        this.addVehicleTypeInToList();
        this.initDriverCampaignList();
        this.isViewInitialized = true;
        if (this.operatorEmbedded) {
            if (this.driverId > 0) {
                this.handleTabChange(this.activeTab);
            }
            return;
        }
        if (this.isActiveDrivers) {
            const canOpenCommerce = this.isCommerceTab && !this.isOperatorAccount;
            const tab = canOpenCommerce ? MenuTab.Commerce : MenuTab.DriverStats;
            this.activeTab = tab;
            this.handleTabChange(tab);
        }
    }

    showEditProfileDialog() {
        this.emailExist = false;
        this.phoneExist = false;
        this.displayEditProfileDialog = true;
    }

    toggleExportSidebar(val: boolean) {
        this.showExportSidebar = val;
    }

    toggleOrdersExportSidebar(val: boolean) {
        this.showOrdersExportSidebar = val;
    }

    exportTransactions() {
        if (!this.exportData.fileType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select file type' });
            return;
        }

        const [startDate, endDate] = this.selectedDateRange || [];
        const dto = {
            RiderId: this.driverId,
            RiderName: this.driver.UserName,
            ReportType: FinanceMenuEnum.WalletTransactionHistory,
            FileType: this.exportData.fileType,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            SortField: 'TransactionId',
            ClientLocationType: this.appData.getClientLocationType(),
            Filter: {
                StartDate: startDate ? moment(startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
                EndDate: endDate ? moment(endDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            },
        };

        this.exportLoading = true;
        this.deliveryOrderService.exportTransactions(dto, this.messageService)
			.then(data => {
				if (!data || !data.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage || 'Export failed' });
					this.exportLoading = false;
					return;
				}
				const fileDownloaded = Utils.saveFileFromBase64Response(data, 'DriverTransactions_' + moment(new Date()).format('DD MMM YYYY hh:mm:ss A'));
				if (fileDownloaded) {
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Export completed successfully' });
				} else {
					this.messageService.add({ severity: 'warn', summary: 'No Data', detail: 'No driver transactions found to export' });
				}
                this.exportLoading = false;
            })
            .catch(err => {
                this.exportLoading = false;
                throw err;
            });
    }

    exportOrders() {
        if (!this.exportData.fileType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select file type' });
            return;
        }

        const [startDate, endDate] = this.selectedDateRange || [];

        const dto = {
            XpressRiderId: this.driverId,
            RiderName: this.driver.UserName,
            StartDate: startDate ? moment(startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            EndDate: endDate ? moment(endDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            ClientLocationType: this.appData.getClientLocationType(),
            FileType: this.exportData.fileType,
        };

        this.exportLoading = true;
        this.deliveryOrderService.exportBookings(dto, this.messageService)
            .then(data => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Success' });
                Utils.saveFileResponse(data, 'DriverOrders_' + moment(new Date()).format('DDMMYY'), this.exportData.fileType);
                this.exportLoading = false;
            })
            .catch(err => {
                this.exportLoading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err });
            });
    }

    public removeDriverLink() {
        this.isSpinnerVisible = true;
        const dto = {
            OperatorId: this.appData.authData.OperatorId,
            RiderId: this.driver.XpressRiderId
        };
        this.riderService.removeRiderOperatorMapping(dto, this.messageService)
            .then(data => {
                this.isSpinnerVisible = false;
                this.removeDriver = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.changedVisibleDetail(!this.visibleDetail);
                this.messageService.add({ severity: 'success', summary: 'Saved!', detail: 'Driver removed successfully.' });
            })
            .catch(err => {
                this.isSpinnerVisible = false;
                throw err;
            });
    }

    public async checkPhone(): Promise<boolean | null> {
        if (!this.driver.Phone || this.driver.Phone === this.initialDriver?.Phone) {
            this.phoneExist = false;
            return this.phoneExist;
        }
        const dto = {
            Phone: this.driver.Phone,
            RoleId: XpressUserRoleEnum.Rider
        };
        try {
            const data = await this.userService.checkPhone(dto, this.messageService);
            if (!data || !data.Success) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: data?.ErrorMessage || 'Failed to verify phone number. Please try again.'
                });
                return null;
            }
            this.phoneExist = data.Found;
            return this.phoneExist;
        } catch (err) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to verify phone number. Please try again.' });
            return null;
        }
    }

    public async checkEmail(): Promise<boolean | null> {
        if (!this.driver.Email || this.driver.Email === this.initialDriver?.Email) {
            this.emailExist = false;
            return this.emailExist;
        }
        const dto = {
            Email: this.driver.Email,
        };
        try {
            const data = await this.userService.checkEmail(dto, this.messageService);
            if (!data || !data.Success) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: data?.ErrorMessage || 'Failed to verify email. Please try again.'
                });
                return null;
            }
            this.emailExist = data.Found;
            return this.emailExist;
        } catch (err) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to verify email. Please try again.' });
            return null;
        }
    }

    public async updateUserProfile() {
        const isRiderProfile = this.driver?.XpressRiderId != null;
        const isRequiredFieldMissing =
            !this.driver.FirstName.trim()
            || !this.driver.LastName.trim()
            || !this.driver.Email.trim()
            || !this.driver.Phone.trim()
            || !this.driver.Gender
            || !this.driver.BirthDate
            || !this.driver.Address.trim()
            || !this.driver.EmergencyContactPerson?.trim()
            || !this.driver.EmergencyContactNumber?.trim();

        if (isRiderProfile && isRequiredFieldMissing) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Please enter all required fields.',
            });
            return;
        }

        this.isSpinnerVisible = true;
        this.driver.Id = this.driver.XpressUserId;
        this.driver.Phone = this.driver.Phone.replace(/' '/g, '');
        this.driver.TimezoneOffset = Utils.getTimezoneOffset();

        try {
            const [phoneExists, emailExists] = await Promise.all([
                this.checkPhone(),
                this.checkEmail()
            ]);

            // null means uniqueness could not be confirmed (failed/errored check) - never
            // treat that as "safe to save", or a duplicate could slip through undetected.
            if (phoneExists === null || emailExists === null || phoneExists || emailExists) {
                return;
            }

            const data = await this.userService.updateUserProfile(this.driver, this.messageService);
            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.getRiderInfo();
            this.displayEditProfileDialog = false;
            this.messageService.add({ severity: 'success', summary: 'Saved!', detail: 'Profile updated successfully.' });
        } catch (error) {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Something went wrong. Please try again.',
            });
        } finally {
            this.isSpinnerVisible = false;
        }
    }

    public discardChanges() {
        this.discardConfirmDialog = true;
    }

    public cancelDiscard() {
        this.discardConfirmDialog = false;
    }

    public discardConfirm() {
        this.driver = JSON.parse(JSON.stringify(this.initialDriver));
        this.driver.BirthDate = new Date(this.initialDriver.BirthDate);
        this.emailExist = false;
        this.phoneExist = false;
        this.discardConfirmDialog = false;
    }

    public activeHoursChartInit(): void {
        this.activeHoursChartData = {
            labels: this.riderStatistics.ActiveHoursLabels,
            datasets: [
                {
                    type: 'bar',
                    backgroundColor: this.riderStatistics.ColumnColors,
                    data: this.riderStatistics.ActiveHoursStat,
                    borderRadius: 4
                }
            ]
        };

        this.activeHoursChartOptions = {
            onHover: (event: any, chartElements: any) => {
                if (chartElements.length > 0) {
                    this.onActiveHoursHover('#CCD9DF', chartElements[0].index, true);
                } else {
                    this.onActiveHoursHover('#004060');
                }
            },
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    padding: {
                        left: 12,
                        right: 60,
                        top: 12,
                        bottom: 12
                    },
                    xAlign: 'left',
                    backgroundColor: 'white',
                    borderWidth: 1,
                    borderColor: '#BDBDBD',
                    titleColor: '#BDBDBD',
                    titleFont: { size: 12, weight: 500, family: 'Poppins, sans-serif' },
                    bodyColor: '#6B7280',
                    bodyFont: { size: 12, family: 'Poppins, sans-serif' },
                    footerColor: '#03233A',
                    footerFont: { size: 18, weight: 500, family: 'Poppins, sans-serif' },
                    titleMarginBottom: 20,
                    displayColors: false,
                    callbacks: {
                        title: (tooltipItem: any, data: any) => 'Active Hours',
                        label: (tooltipItem: any, data: any) => this.riderStatistics.ActiveDaysLabels[tooltipItem.dataIndex],
                        footer: (tooltipItem: any, data: any) => {
                            if (tooltipItem[0] && tooltipItem[0].formattedValue) {
                                const tmp = tooltipItem[0].formattedValue.includes('.')
                                    ? tooltipItem[0].formattedValue.split('.')
                                    : tooltipItem[0].formattedValue.split(',');

                                const hours = tmp[0] + 'h ';
                                const minutes = String(Math.round((parseInt(tmp[1], 10) * 60) / 1000)).padEnd(2, '0') + 'm';
                                return hours + minutes;
                            }
                            return '';
                        },
                    },
                }
            }
        };
    }

    onActiveHoursHover(color: string, index: number = 0, isBarHovered: boolean = false) {
        for (let i = 0; i < this.activeHoursChartData.datasets[0].backgroundColor.length; i++) {
            this.activeHoursChartData.datasets[0].backgroundColor[i] = color;
        }
        if (isBarHovered) {
            this.activeHoursChartData.datasets[0].backgroundColor[index] = '#004060';
        }
        this.chart.chart.update();
    }

    getPerfRate(rateType: RateType, rateValue: number): PerformanceRate {
        switch (rateType) {
            case RateType.Completion:
            case RateType.Acceptance:
                if (rateValue > 70) {
                    return PerformanceRate.Good;
                } else if (rateValue <= 70 && rateValue > 50) {
                    return PerformanceRate.Medium;
                } else {
                    return PerformanceRate.Bad;
                }
            case RateType.Cancellation:
                if (rateValue < 30) {
                    return PerformanceRate.Good;
                } else if (rateValue >= 30 && rateValue <= 50) {
                    return PerformanceRate.Medium;
                } else {
                    return PerformanceRate.Bad;
                }
            default: return PerformanceRate.None;
        }
    }

    public getPerfCardColors(rateType: RateType, rateValue: number): StylesPerfCard {
        let backgroundColor: string;
        let borderColor: string;
        switch (rateType) {
            case RateType.Completion:
            case RateType.Acceptance:
                if (rateValue > 70) {
                    backgroundColor = '#CEE6FF';
                    borderColor = '#0A84FF';
                } else if (rateValue <= 70 && rateValue > 50) {
                    backgroundColor = '#FDE5CC';
                    borderColor = '#F77F00';
                } else {
                    backgroundColor = '#FEDED8';
                    borderColor = '#EB4236';
                }
                break;
            case RateType.Cancellation:
                if (rateValue < 30) {
                    backgroundColor = '#CEE6FF';
                    borderColor = '#0A84FF';
                } else if (rateValue >= 30 && rateValue <= 50) {
                    backgroundColor = '#FDE5CC';
                    borderColor = '#F77F00';
                } else {
                    backgroundColor = '#FEDED8';
                    borderColor = '#EB4236';
                }
                break;
            default:
                backgroundColor = '';
                borderColor = '';
        }

        return {
            backgroundColor,
            borderColor
        };
    }

    //start profile photo galleria
    public infoItems: any = [];
    public activeImgIndex: number = 0;
    public displayImg: boolean = false;
    public imageOptions: any[] = [
        {
            breakpoint: '1500px',
            numVisible: 5
        },
        {
            breakpoint: '1024px',
            numVisible: 3
        },
        {
            breakpoint: '768px',
            numVisible: 2
        },
        {
            breakpoint: '560px',
            numVisible: 1
        }
    ];

    public showDriverPhotoImageModal() {
        this.infoItems = [{ value: this.riderStatistics.RiderImageUrl }];
        this.displayImg = true;
    }

    public showDocumentImageModal(items: any, index: number) {
        this.infoItems = items;
        this.activeImgIndex = index;
        this.displayImg = true;
    }
    //end profile photo galleria

    //start docs gallerias
    public identifDocsImgs: any = [];
    public identifDocsImgIndex: number = 0;

    public vehicleDocsImgs: any = [];
    public vehicleDocsImgIndex: number = 0;

    public TNVSDocsImgs: any = [];
    public TNVSDocsImgIndex: number = 0;
    public riderApplicationDetails: any = null;

    public legalDocGroups: LegalDocGroup[] = [];
    public expandedLegalCardKey: string | null = null;
    public editingLegalCardKey: string | null = null;
    public savingLegalCardKey: string | null = null;
    public readonly legalDocLicenseTypeOptions = [
        { label: 'Professional', value: XpressDocumentTypeEnum.DriverLicenseProfessional },
        { label: 'Non-Professional', value: XpressDocumentTypeEnum.DriverLicenseNonProfessional }
    ];
    public readonly legalDocColorOptions = ColorTypeSelection.ColorTypeList;
    public readonly legalDocPaCpcTypeOptions = [
        { label: 'PA', value: XpressDocumentTypeEnum.Pa },
        { label: 'CPC', value: XpressDocumentTypeEnum.Cpc }
    ];
    public readonly legalDocRidesharingAppOptions = RidesharingAppModel.RidesharingAppModelList
        .filter((o: any) => o.value !== null);
    public vehicleBrands: VehicleBrandModel[] = [];
    public vehicleModels: VehicleModel[] = [];
    private vehicleBrandModelsLoaded: boolean = false;
    public driverLicenseExpirationDate: Date | string | null = null;
    public nbiExpirationDate: Date | string | null = null;
    public orCrExpirationDate: Date | string | null = null;
    public paCpcExpirationDate: Date | string | null = null;

    private getApplicationDocuments(...types: XpressDocumentTypeEnum[]): any[] {
        const documents = this.riderApplicationDetails?.Documents;
        if (!Array.isArray(documents)) {
            return [];
        }

        const matchedDocuments = documents
            .filter((doc: any) => types.includes(doc?.Type))
            .sort((a: any, b: any) => (b?.DocumentId || 0) - (a?.DocumentId || 0));

        const latestByType = new Map<number, any>();
        matchedDocuments.forEach((doc: any) => {
            const typeKey = Number(doc?.Type);
            if (!latestByType.has(typeKey)) {
                latestByType.set(typeKey, doc);
            }
        });

        return Array.from(latestByType.values());
    }

    private mapApplicationDocumentsToGalleryItems(docs: any[], title: string, subTitle: string = ''): any[] {
        if (!Array.isArray(docs) || docs.length === 0) {
            return [];
        }

        const files = docs
            .filter((doc: any) => Array.isArray(doc?.Files))
            .flatMap((doc: any) => doc.Files)
            .filter((file: any) => this.notEmpty(file?.ImageUrl));

        const addIndexToTitle = files.length > 1;

        return files.map((file: any, index: number) => ({
            value: file.IsPdf ? null : file.ImageUrl,
            valuePdf: file.IsPdf ? (file.SafeUrl || this.getSafeUrl(file.ImageUrl)) : null,
            title: addIndexToTitle ? `${title} ${index + 1}` : title,
            subTitle
        }));
    }

    private hydrateDocumentDatesFromApplication(): void {
        if (!this.riderApplicationDetails) {
            this.driverLicenseExpirationDate = null;
            this.nbiExpirationDate = null;
            this.orCrExpirationDate = null;
            this.paCpcExpirationDate = null;
            return;
        }

        this.driverLicenseExpirationDate = this.riderApplicationDetails.DriverLicenseExpirationDate ?? null;
        this.nbiExpirationDate = this.riderApplicationDetails.NbiExpirationDate ?? null;
        this.orCrExpirationDate = this.riderApplicationDetails.OrCrExpirationDate ?? null;
        this.paCpcExpirationDate = this.riderApplicationDetails.PaCpcExpirationDate ?? null;
    }

    private async loadRiderApplicationDetails(): Promise<void> {
        this.riderApplicationDetails = null;
        this.hydrateDocumentDatesFromApplication();

        if (!this.driverId || !this.driver?.XpressUserId) {
            return;
        }

        try {
            let vehicleServiceTypeId = this.vehicles?.find((v: any) => v?.IsActive)?.VehicleServiceTypeId
                ?? this.vehicles?.[0]?.VehicleServiceTypeId;

            if (!vehicleServiceTypeId) {
                const vehiclesResponse = await this.riderService.getRiderVehicles({ RiderId: this.driverId }, this.messageService);
                if (vehiclesResponse?.Success && Array.isArray(vehiclesResponse.Items) && vehiclesResponse.Items.length > 0) {
                    const activeVehicle = vehiclesResponse.Items.find((v: any) => v?.IsActive) ?? vehiclesResponse.Items[0];
                    vehicleServiceTypeId = activeVehicle?.VehicleServiceTypeId;
                }
            }

            if (!vehicleServiceTypeId) {
                return;
            }

            const detailsResponse = await this.riderService.getRiderApplicationDetails({
                XpressUserId: this.driver.XpressUserId,
                RiderId: this.driverId,
                RiderVehicleServiceTypeId: vehicleServiceTypeId
            }, this.messageService);

            if (!detailsResponse?.Success) {
                return;
            }

            detailsResponse.Documents?.forEach((doc: any) => {
                doc?.Files?.forEach((file: any) => {
                    if (file?.IsPdf && this.notEmpty(file.ImageUrl)) {
                        file.SafeUrl = this.getSafeUrl(file.ImageUrl);
                    }
                });
            });

            this.riderApplicationDetails = detailsResponse;
            this.hydrateDocumentDatesFromApplication();
        } catch (error) {
            console.log(error);
        }
    }

    public initIdentifDocsImages() {
        const driverLicense = this.getApplicationDocuments(
            XpressDocumentTypeEnum.DriverLicense,
            XpressDocumentTypeEnum.DriverLicenseProfessional,
            XpressDocumentTypeEnum.DriverLicenseNonProfessional
        );
        const nbi = this.getApplicationDocuments(XpressDocumentTypeEnum.NBIClearance);
        const fitToDrive = this.getApplicationDocuments(XpressDocumentTypeEnum.FitToDriveCertificate);
        const previousAppExperience = this.getApplicationDocuments(XpressDocumentTypeEnum.PreviousAppExperience);

        const driverLicenseSubtitle = this.notEmpty(this.driverLicenseExpirationDate)
            ? 'Expiration date: ' + moment(this.driverLicenseExpirationDate).format('MMMM DD, YYYY')
            : '';
        const nbiSubtitle = this.notEmpty(this.nbiExpirationDate)
            ? 'Expiration date: ' + moment(this.nbiExpirationDate).format('MMMM DD, YYYY')
            : '';

        const appDocs = [
            ...this.mapApplicationDocumentsToGalleryItems(driverLicense, 'Driver\'s License', driverLicenseSubtitle),
            ...this.mapApplicationDocumentsToGalleryItems(nbi, 'NBI Clearance', nbiSubtitle),
            ...this.mapApplicationDocumentsToGalleryItems(fitToDrive, 'Fit to Drive Certificate'),
            ...this.mapApplicationDocumentsToGalleryItems(previousAppExperience, 'Previous App Experience')
        ].filter(f => this.notEmpty(f.value) || this.notEmpty(f.valuePdf));

        this.identifDocsImgs = appDocs.filter(f => this.notEmpty(f.value) || this.notEmpty(f.valuePdf));
    }

    public initVehicleDocsImages() {
        const orCr = this.getApplicationDocuments(XpressDocumentTypeEnum.OfficialReceiptAndCertificateOfRegistration);
        const authorizationLetter = this.getApplicationDocuments(XpressDocumentTypeEnum.AuthorizationLetter);
        const notarizedSpa = this.getApplicationDocuments(XpressDocumentTypeEnum.NotarizedSPA);
        const deedOfSale = this.getApplicationDocuments(XpressDocumentTypeEnum.DeedOfSale);
        const certificateOfSale = this.getApplicationDocuments(XpressDocumentTypeEnum.CertificateOfSale);

        const orCrSubtitle = this.notEmpty(this.orCrExpirationDate)
            ? 'Expiration date: ' + moment(this.orCrExpirationDate).format('MMMM DD, YYYY')
            : '';

        const appDocs = [
            ...this.mapApplicationDocumentsToGalleryItems(orCr, 'OR/CR', orCrSubtitle),
            ...this.mapApplicationDocumentsToGalleryItems(authorizationLetter, 'Authorization Letter'),
            ...this.mapApplicationDocumentsToGalleryItems(notarizedSpa, 'Notarized SPA'),
            ...this.mapApplicationDocumentsToGalleryItems(deedOfSale, 'Deed of Sale'),
            ...this.mapApplicationDocumentsToGalleryItems(certificateOfSale, 'Certificate of Sale')
        ].filter(f => this.notEmpty(f.value) || this.notEmpty(f.valuePdf));
        this.vehicleDocsImgs = appDocs;
    }

    public initTNVSDocsImgs() {
        const paOrCpc = this.getApplicationDocuments(
            XpressDocumentTypeEnum.PaOrCpc,
            XpressDocumentTypeEnum.Pa,
            XpressDocumentTypeEnum.Cpc
        );
        const paOrCpcSubtitle = this.notEmpty(this.paCpcExpirationDate)
            ? 'Expiration date: ' + moment(this.paCpcExpirationDate).format('MMMM DD, YYYY')
            : '';

        const appDocs = [
            ...this.mapApplicationDocumentsToGalleryItems(paOrCpc, 'PA/CPC', paOrCpcSubtitle)
        ].filter(f => this.notEmpty(f.value) || this.notEmpty(f.valuePdf));
        this.TNVSDocsImgs = appDocs;
    }
    //end docs gallerias

    //start legal documents cards
    public resetLegalDocumentsState(): void {
        this.legalDocGroups = [];
        this.expandedLegalCardKey = null;
        this.editingLegalCardKey = null;
        this.savingLegalCardKey = null;
        this.vehicleModels = [];

        // Drop the previous driver's vehicle cache. loadRiderApplicationDetails, legal card
        // building and saveLegalCard all resolve the active vehicle from this list, so leaving
        // stale data would key application details off the prior rider's VehicleServiceTypeId,
        // show wrong OR/CR metadata, and post updates with the wrong RiderVehicleId.
        this.vehicles = [];
        this.selectedVehicle = undefined;

        // Drop the previous driver's application data so the Legal tab reloads it and no
        // rebuild (e.g. a completing getRiderVehicles) renders cards from stale details.
        this.riderApplicationDetails = null;
        this.driverLicenseExpirationDate = null;
        this.nbiExpirationDate = null;
        this.orCrExpirationDate = null;
        this.paCpcExpirationDate = null;
    }

    public async onLegalDocumentTabOpen(): Promise<void> {
        this.loadVehicleBrandModels();

        if (!this.riderApplicationDetails) {
            await this.loadRiderApplicationDetails();
            this.updateCarouselImages();
        }

        this.getRiderVehicles();
    }

    public async loadVehicleBrandModels(): Promise<void> {
        if (this.vehicleBrandModelsLoaded) {
            return;
        }

        try {
            const brandsData = await this.vehicleBrandService.getVehicleBrands({ VehicleType: null }, this.messageService);
            if (brandsData?.Success && Array.isArray(brandsData.Items)) {
                this.vehicleBrands = VehicleBrandModel.mapToVehicleBrandModels(brandsData.Items);
                this.vehicleBrandModelsLoaded = true;
            }
        } catch (error) {
            console.log(error);
        }
    }

    public async loadVehicleModelsForBrand(brandId: number | null | undefined): Promise<void> {
        if (!brandId) {
            this.vehicleModels = [];
            return;
        }

        try {
            const vehicleType = this.riderApplicationDetails?.VehicleType ?? null;
            const modelsData = await this.vehicleBrandService.getVehicleModels(
                { VehicleBrandId: brandId, VehicleType: vehicleType }, this.messageService);
            this.vehicleModels = (modelsData?.Success && Array.isArray(modelsData.Items))
                ? VehicleModel.mapToVehicleModels(modelsData.Items)
                : [];
        } catch (error) {
            this.vehicleModels = [];
            console.log(error);
        }
    }

    public async onLegalCardBrandChange(card: LegalDocCard): Promise<void> {
        card.edit.modelId = null;
        await this.loadVehicleModelsForBrand(card.edit.brandId);
    }

    private getActiveVehicle(): any {
        if (this.selectedVehicle) {
            return this.selectedVehicle;
        }
        if (Array.isArray(this.vehicles)) {
            return this.vehicles.find((v: any) => v?.IsActive) ?? this.vehicles[0] ?? null;
        }
        return null;
    }

    // Legal documents must always reflect the rider's active vehicle, mirroring the backend
    // (GetRiderApplicationDetails / UpdateRiderInfoV2 resolve the vehicle by IsActive). This must
    // not depend on selectedVehicle, which only tracks the vehicle opened in the Vehicles UI and
    // would otherwise skew OR/CR + vehicle photo metadata and target the wrong RiderVehicleId on save.
    private getLegalActiveVehicle(): any {
        if (Array.isArray(this.vehicles)) {
            return this.vehicles.find((v: any) => v?.IsActive) ?? this.vehicles[0] ?? null;
        }
        return null;
    }

    private mapLegalDocFiles(docs: any[], prefix: string): LegalDocFile[] {
        const files = (Array.isArray(docs) ? docs : [])
            .filter((doc: any) => Array.isArray(doc?.Files))
            .flatMap((doc: any) => doc.Files)
            .filter((file: any) => this.notEmpty(file?.ImageUrl));

        return files.map((file: any, index: number) => ({
            fileId: file.FileId,
            name: `${prefix}_${String(index + 1).padStart(2, '0')}.${file.IsPdf ? 'pdf' : 'jpg'}`,
            imageUrl: file.ImageUrl,
            safeUrl: file.IsPdf ? (file.SafeUrl || this.getSafeUrl(file.ImageUrl)) : null,
            isPdf: !!file.IsPdf
        }));
    }

    private resolveExpiryStatus(date: Date | string | null): LegalDocStatus {
        if (this.isDocExpired(date)) {
            return 'Expired';
        }
        if (this.isDocExpiring(date)) {
            return 'Expiring';
        }
        return 'Valid';
    }

    private resolveDocStatus(date: Date | string | null, docs: any[]): LegalDocStatus {
        // Verification outcome takes precedence: a rejected / action-required document
        // must not appear as Valid just because it still has a future expiry date.
        const verification = this.resolveVerificationStatus(docs);
        if (verification === 'Rejected' || verification === 'Action Required') {
            return verification;
        }

        // Approved: surface expiry state when a date exists, otherwise just Approved.
        return this.notEmpty(date)
            ? this.resolveExpiryStatus(date)
            : 'Approved';
    }

    private resolveVerificationStatus(docs: any[]): LegalDocStatus {
        const statuses = (Array.isArray(docs) ? docs : []).map((d: any) => Number(d?.Status));
        if (statuses.length === 0) {
            return 'Action Required';
        }
        if (statuses.some(s => s === 3)) {
            return 'Rejected';
        }
        if (statuses.every(s => s === 2)) {
            return 'Approved';
        }
        return 'Action Required';
    }

    private makeReadOnlyDocCard(
        key: string,
        group: string,
        title: string,
        uploadSource: string,
        docs: any[],
        prefix: string,
        status?: LegalDocStatus
    ): LegalDocCard {
        const ad = this.riderApplicationDetails ?? {};
        return {
            key,
            group,
            title,
            uploadSource,
            required: false,
            uploadedBy: 'Applicant',
            uploadedAt: this.notEmpty(ad.SignUpDate) ? ad.SignUpDate : '',
            status: status ?? this.resolveVerificationStatus(docs),
            files: this.mapLegalDocFiles(docs, prefix),
            detailRows: [],
            editFields: [],
            newFiles: [],
            removedFileIds: [],
            edit: {}
        };
    }

    private makeDriverImageCard(
        key: string,
        group: string,
        title: string,
        imageUrl: string,
        pdfImageUrl: string,
        prefix: string,
        status: LegalDocStatus
    ): LegalDocCard | null {
        if (!this.notEmpty(imageUrl) && !this.notEmpty(pdfImageUrl)) {
            return null;
        }
        const ad = this.riderApplicationDetails ?? {};
        const isPdf = this.notEmpty(pdfImageUrl);
        const file: LegalDocFile = {
            name: `${prefix}_01.${isPdf ? 'pdf' : 'jpg'}`,
            imageUrl: imageUrl || '',
            safeUrl: isPdf ? pdfImageUrl : null,
            isPdf
        };
        return {
            key,
            group,
            title,
            uploadSource: 'App Upload',
            required: false,
            uploadedBy: 'Applicant',
            uploadedAt: this.notEmpty(ad.SignUpDate) ? ad.SignUpDate : '',
            status,
            files: [file],
            detailRows: [],
            editFields: [],
            newFiles: [],
            removedFileIds: [],
            edit: {}
        };
    }

    // V2 (and other) driver-only application documents not covered by the classic card builders.
    private buildDriverSourcedCards(): LegalDocCard[] {
        const ad = this.riderApplicationDetails ?? {};
        const uploadedAt = this.notEmpty(ad.SignUpDate) ? ad.SignUpDate : '';
        const uploadedBy = 'Applicant';
        const cards: LegalDocCard[] = [];

        const medicalDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.MedicalExamResults);
        if (medicalDocs.length > 0) {
            cards.push({
                key: 'medicalExam',
                group: 'Identification',
                title: 'Medical Exam Results',
                uploadSource: 'App Upload',
                required: false,
                uploadedBy,
                uploadedAt,
                status: this.resolveVerificationStatus(medicalDocs),
                files: this.mapLegalDocFiles(medicalDocs, 'medicalExam'),
                detailRows: [
                    { label: 'Medical Exam Date', value: this.formatLegalDate(ad.MedicalExamDate) }
                ],
                editFields: [],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        const sssDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.SssNumberProof);
        if (sssDocs.length > 0) {
            cards.push({
                key: 'sssNumber',
                group: 'Identification',
                title: 'SSS Number Proof',
                uploadSource: 'App Upload',
                required: false,
                uploadedBy,
                uploadedAt,
                status: this.resolveVerificationStatus(sssDocs),
                files: this.mapLegalDocFiles(sssDocs, 'sss'),
                detailRows: [
                    { label: 'SSS Number', value: this.notEmpty(ad.SssNumber) ? ad.SssNumber : '\u2014' }
                ],
                editFields: [],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        const pagIbigDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.PagIbigNumberProof);
        if (pagIbigDocs.length > 0) {
            cards.push({
                key: 'pagIbigNumber',
                group: 'Identification',
                title: 'Pag-IBIG Number Proof',
                uploadSource: 'App Upload',
                required: false,
                uploadedBy,
                uploadedAt,
                status: this.resolveVerificationStatus(pagIbigDocs),
                files: this.mapLegalDocFiles(pagIbigDocs, 'pagIbig'),
                detailRows: [
                    { label: 'Pag-IBIG Number', value: this.notEmpty(ad.PagIbigNumber) ? ad.PagIbigNumber : '\u2014' }
                ],
                editFields: [],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        const philHealthDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.PhilHealthNumberProof);
        if (philHealthDocs.length > 0) {
            cards.push({
                key: 'philHealthNumber',
                group: 'Identification',
                title: 'PhilHealth Number Proof',
                uploadSource: 'App Upload',
                required: false,
                uploadedBy,
                uploadedAt,
                status: this.resolveVerificationStatus(philHealthDocs),
                files: this.mapLegalDocFiles(philHealthDocs, 'philHealth'),
                detailRows: [
                    { label: 'PhilHealth Number', value: this.notEmpty(ad.PhilHealthNumber) ? ad.PhilHealthNumber : '\u2014' }
                ],
                editFields: [],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        return cards;
    }

    private getTinLegalDocuments(): any[] {
        const documents = this.riderApplicationDetails?.Documents;
        if (!Array.isArray(documents)) {
            return [];
        }

        const tinDocs = documents
            .filter((doc: any) => Number(doc?.Type) === XpressDocumentTypeEnum.TinNumberProof)
            .sort((a: any, b: any) => (b?.DocumentId || 0) - (a?.DocumentId || 0));
        const approved = tinDocs.filter((doc: any) =>
            Number(doc?.Status) === XpressRiderDocumentVerificationStatusEnum.Approved);

        return approved.length > 0 ? approved : tinDocs.slice(0, 1);
    }

    private buildTinNumberCard(): LegalDocCard {
        const ad = this.riderApplicationDetails ?? {};
        const tinDocs = this.getTinLegalDocuments();
        const files = this.mapLegalDocFiles(tinDocs, 'tin');
        const hasEncodedDetails = this.notEmpty(ad.TinNumber) && this.notEmpty(ad.TinRegisteredName);
        const hasTinRecord = tinDocs.length > 0 || hasEncodedDetails;

        return {
            key: 'tinNumber',
            group: 'Identification',
            title: 'TIN Number Proof',
            uploadSource: 'App Upload',
            required: true,
            uploadedBy: hasTinRecord ? 'Applicant' : '',
            uploadedAt: hasTinRecord && this.notEmpty(ad.SignUpDate) ? ad.SignUpDate : '',
            checkType: LegalDocVerificationCheck.TinNumberProof,
            status: this.resolveVerificationStatus(tinDocs),
            files,
            detailRows: [
                { label: 'TIN Number', value: this.notEmpty(ad.TinNumber) ? ad.TinNumber : '\u2014' },
                { label: 'Registered Name', value: this.notEmpty(ad.TinRegisteredName) ? ad.TinRegisteredName : '\u2014' }
            ],
            // Save requires application details. Keep the fallback card view-only
            // until they load so Edit Details cannot open a save that always fails.
            editFields: this.riderApplicationDetails
                ? [
                    { key: 'tinNumber', label: 'TIN Number', type: 'text' },
                    { key: 'tinRegisteredName', label: 'Registered Name', type: 'text' }
                ]
                : [],
            newFiles: [],
            removedFileIds: [],
            edit: {}
        };
    }

    private finalizeLegalDocGroups(
        identification: LegalDocCard[],
        vehicleAndRequirement: LegalDocCard[],
        tnvsDocuments: LegalDocCard[],
        previouslyExpandedKey: string | null
    ): void {
        const groups: LegalDocGroup[] = [];
        if (identification.length > 0) {
            groups.push({ title: 'Identification', cards: identification });
        }
        // Operators review driver documents only; vehicle / TNVS docs live on the Vehicles flow.
        if (!this.isOperator) {
            if (vehicleAndRequirement.length > 0) {
                groups.push({ title: 'Vehicle & Requirement Documents', cards: vehicleAndRequirement });
            }
            if (tnvsDocuments.length > 0) {
                groups.push({ title: 'TNVS Documents', cards: tnvsDocuments });
            }
        }
        this.legalDocGroups = groups;

        const stillExists = groups.some(g => g.cards.some(c => c.key === previouslyExpandedKey));
        this.expandedLegalCardKey = stillExists ? previouslyExpandedKey : null;
    }

    public buildLegalDocumentCards(): void {
        // Preserve unsaved inline edits: don't rebuild (and discard edits) while a card is being edited.
        if (this.editingLegalCardKey) {
            return;
        }

        const previouslyExpandedKey = this.expandedLegalCardKey;
        this.legalDocGroups = [];
        this.expandedLegalCardKey = null;

        const ad = this.riderApplicationDetails;
        if (!ad) {
            // No application details yet: still surface driver-sourced documents (e.g. medical
            // certificate) instead of leaving the tab empty.
            const fallbackCards = [this.buildTinNumberCard(), ...this.buildDriverSourcedCards()];
            this.finalizeLegalDocGroups(fallbackCards, [], [], previouslyExpandedKey);
            return;
        }

        // Vehicles may not be loaded yet (they are fetched on tab open). Trigger a load so
        // OR/CR and vehicle photo rows get real plate/make/model instead of placeholders.
        // getRiderVehicles() rebuilds these cards once the data arrives.
        if ((!Array.isArray(this.vehicles) || this.vehicles.length === 0) && !this.isVehicleSpinner) {
            this.getRiderVehicles();
        }

        const vehicle = this.getLegalActiveVehicle();
        const uploadedAt = this.notEmpty(ad.SignUpDate) ? ad.SignUpDate : '';
        const uploadedBy = 'Applicant';

        const licenseDocs = this.getApplicationDocuments(
            XpressDocumentTypeEnum.DriverLicense,
            XpressDocumentTypeEnum.DriverLicenseProfessional,
            XpressDocumentTypeEnum.DriverLicenseNonProfessional
        );
        const nbiDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.NBIClearance);
        const policeClearanceDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.PoliceClearance);
        // Trust declared ClearanceType for title/check binding; only infer from files when unset.
        const isPoliceClearance = ad.ClearanceType === XpressDocumentTypeEnum.PoliceClearance
            || (ad.ClearanceType == null && nbiDocs.length === 0 && policeClearanceDocs.length > 0);
        const clearanceDocs = isPoliceClearance
            ? (policeClearanceDocs.length > 0 ? policeClearanceDocs : nbiDocs)
            : (nbiDocs.length > 0 ? nbiDocs : policeClearanceDocs);
        const orCrDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.OfficialReceiptAndCertificateOfRegistration);
        const vehiclePhotoDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.VehiclePhoto);
        const paCpcDocs = this.getApplicationDocuments(
            XpressDocumentTypeEnum.PaOrCpc,
            XpressDocumentTypeEnum.Pa,
            XpressDocumentTypeEnum.Cpc
        );

        const licenseTypeText = ad.DriverLicenseType === XpressDocumentTypeEnum.DriverLicenseNonProfessional
            ? 'Non-Professional'
            : 'Professional';
        const paCpcTypeText = ad.PaCpcType === XpressDocumentTypeEnum.Cpc ? 'CPC' : 'PA';
        const clearanceTypeText = isPoliceClearance ? 'Police Clearance' : 'NBI';

        const identification: LegalDocCard[] = [];
        const vehicleAndRequirement: LegalDocCard[] = [];
        const tnvsDocuments: LegalDocCard[] = [];

        if (licenseDocs.length > 0) {
            identification.push({
                key: 'license',
                group: 'Identification',
                title: `${licenseTypeText} Driver\u2019s License`,
                uploadSource: 'App Upload',
                required: true,
                uploadedBy,
                uploadedAt,
                checkType: LegalDocVerificationCheck.DriverLicense,
                status: this.resolveDocStatus(this.driverLicenseExpirationDate, licenseDocs),
                files: this.mapLegalDocFiles(licenseDocs, 'license'),
                detailRows: [
                    { label: 'License Number', value: ad.DriverLicenseNumber || '\u2014' },
                    { label: 'License Type', value: licenseTypeText },
                    { label: 'Expiry Date', value: this.formatLegalDate(this.driverLicenseExpirationDate) }
                ],
                editFields: [
                    { key: 'licenseNumber', label: 'License Number', type: 'text' },
                    { key: 'licenseType', label: 'License Type', type: 'license' },
                    { key: 'licenseExpiry', label: 'Expiry Date', type: 'date' }
                ],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        if (clearanceDocs.length > 0) {
            identification.push({
                key: 'nbi',
                group: 'Identification',
                title: isPoliceClearance ? 'Police Clearance' : 'NBI Clearance',
                uploadSource: 'App Upload',
                required: true,
                uploadedBy,
                uploadedAt,
                checkType: isPoliceClearance
                    ? LegalDocVerificationCheck.PoliceClearance
                    : LegalDocVerificationCheck.Nbi,
                status: this.resolveDocStatus(this.nbiExpirationDate, clearanceDocs),
                files: this.mapLegalDocFiles(clearanceDocs, isPoliceClearance ? 'policeClearance' : 'nbi'),
                detailRows: [
                    { label: 'Submitted Clearance Type', value: clearanceTypeText },
                    { label: 'Valid Until', value: this.formatLegalDate(this.nbiExpirationDate) }
                ],
                editFields: [
                    { key: 'nbiValidUntil', label: 'Valid Until', type: 'date' }
                ],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        identification.push(this.buildTinNumberCard());

        if (orCrDocs.length > 0) {
            vehicleAndRequirement.push({
                key: 'orcr',
                group: 'Vehicle & Requirement Documents',
                title: 'OR/CR',
                uploadSource: 'Compliance Upload',
                required: true,
                uploadedBy,
                uploadedAt,
                checkType: LegalDocVerificationCheck.OrCr,
                status: this.resolveDocStatus(this.orCrExpirationDate, orCrDocs),
                files: this.mapLegalDocFiles(orCrDocs, 'orcr'),
                detailRows: [
                    { label: 'Plate Number', value: ad.OrCrPlateNumber || vehicle?.NumberPlate || '\u2014' },
                    { label: 'Vehicle Make', value: vehicle?.VehicleModel || '\u2014' },
                    { label: 'Vehicle Model', value: vehicle?.VehicleModelSeries || '\u2014' },
                    { label: 'Registration Expiry', value: this.formatLegalDate(this.orCrExpirationDate) }
                ],
                editFields: [
                    { key: 'plate', label: 'Plate Number', type: 'text' },
                    { key: 'brandId', label: 'Vehicle Make', type: 'brand' },
                    { key: 'modelId', label: 'Vehicle Model', type: 'model' },
                    { key: 'orCrExpiry', label: 'Registration Expiry', type: 'date' }
                ],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        if (vehiclePhotoDocs.length > 0) {
            vehicleAndRequirement.push({
                key: 'vehiclePhotos',
                group: 'Vehicle & Requirement Documents',
                title: 'Vehicle photo capture / inspection',
                uploadSource: 'App Upload',
                required: true,
                uploadedBy,
                uploadedAt,
                checkType: LegalDocVerificationCheck.VehiclePhotos,
                status: this.resolveVerificationStatus(vehiclePhotoDocs),
                files: this.mapLegalDocFiles(vehiclePhotoDocs, 'vehiclePhotos'),
                detailRows: [
                    { label: 'Vehicle Brand', value: vehicle?.VehicleModel || '\u2014' },
                    { label: 'Vehicle Color', value: ad.VehicleColorText || vehicle?.VehicleColorText || '\u2014' }
                ],
                editFields: [
                    { key: 'color', label: 'Vehicle Color', type: 'color' }
                ],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        const isFourWheeler = this.driver?.VehicleTypeId === RiderVehicleTypeEnum.Sedan
            || this.driver?.VehicleTypeId === RiderVehicleTypeEnum.SUV
            || this.driver?.VehicleTypeId === RiderVehicleTypeEnum.EVCar;

        if (isFourWheeler && paCpcDocs.length > 0) {
            tnvsDocuments.push({
                key: 'pacpc',
                group: 'TNVS Documents',
                title: 'PA or CPC',
                uploadSource: 'Compliance Upload',
                required: true,
                uploadedBy,
                uploadedAt,
                checkType: LegalDocVerificationCheck.PaOrCpc,
                status: this.resolveDocStatus(this.paCpcExpirationDate, paCpcDocs),
                files: this.mapLegalDocFiles(paCpcDocs, 'paCpc'),
                detailRows: [
                    { label: 'Submitted Type', value: paCpcTypeText },
                    { label: 'Case Number', value: ad.PaCpcCaseNumber || '\u2014' },
                    { label: 'Valid Until', value: this.formatLegalDate(this.paCpcExpirationDate) }
                ],
                editFields: [
                    { key: 'paCpcType', label: 'PA or CPC', type: 'pacpc' },
                    { key: 'paCpcCaseNumber', label: 'Case Number', type: 'text' },
                    { key: 'paCpcExpiry', label: 'Valid Until', type: 'date' }
                ],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        // Additional compliance documents (read-only) that were previously shown in the galleries.
        const fitToDriveDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.FitToDriveCertificate);
        if (fitToDriveDocs.length > 0) {
            identification.push(this.makeReadOnlyDocCard(
                'fitToDrive', 'Identification', 'Fit to Drive Certificate', 'App Upload', fitToDriveDocs, 'fitToDrive'));
        }

        const previousExperienceDocs = this.getApplicationDocuments(XpressDocumentTypeEnum.PreviousAppExperience);
        if (previousExperienceDocs.length > 0) {
            const ridesharingAppText = this.notEmpty(ad.RidesharingApp) ? ad.RidesharingApp : '\u2014';
            identification.push({
                key: 'previousExperience',
                group: 'Identification',
                title: 'Previous App Experience',
                uploadSource: 'App Upload',
                required: false,
                uploadedBy,
                uploadedAt,
                checkType: LegalDocVerificationCheck.PreviousAppExperience,
                status: this.resolveVerificationStatus(previousExperienceDocs),
                files: this.mapLegalDocFiles(previousExperienceDocs, 'previousExperience'),
                detailRows: [
                    { label: 'Ride-sharing App', value: ridesharingAppText }
                ],
                editFields: [
                    { key: 'ridesharingAppId', label: 'Ride-sharing App', type: 'ridesharing' }
                ],
                newFiles: [],
                removedFileIds: [],
                edit: {}
            });
        }

        identification.push(...this.buildDriverSourcedCards());

        const authLetterSpaDocs = this.getApplicationDocuments(
            XpressDocumentTypeEnum.AuthorizationLetter,
            XpressDocumentTypeEnum.NotarizedSPA,
            XpressDocumentTypeEnum.AlOrNotarizedSPA
        );
        if (authLetterSpaDocs.length > 0) {
            vehicleAndRequirement.push(this.makeReadOnlyDocCard(
                'authLetterSpa', 'Vehicle & Requirement Documents', 'Authorization Letter / Notarized SPA', 'Compliance Upload', authLetterSpaDocs, 'authLetterSpa'));
        }

        const deedCertOfSaleDocs = this.getApplicationDocuments(
            XpressDocumentTypeEnum.DeedOfSale,
            XpressDocumentTypeEnum.CertificateOfSale,
            XpressDocumentTypeEnum.DeedOfSaleOrCertificateOfSale
        );
        if (deedCertOfSaleDocs.length > 0) {
            vehicleAndRequirement.push(this.makeReadOnlyDocCard(
                'deedCertOfSale', 'Vehicle & Requirement Documents', 'Deed / Certificate of Sale', 'Compliance Upload', deedCertOfSaleDocs, 'deedCertOfSale'));
        }

        this.finalizeLegalDocGroups(identification, vehicleAndRequirement, tnvsDocuments, previouslyExpandedKey);
    }

    private formatLegalDate(date: Date | string | null): string {
        return this.notEmpty(date) ? moment(date).format('YYYY-MM-DD') : '\u2014';
    }

    public legalDocStatusClass(status: LegalDocStatus): string {
        switch (status) {
            case 'Valid':
            case 'Approved':
                return 'legal-doc-badge--ok';
            case 'Expiring':
                return 'legal-doc-badge--warn';
            case 'Expired':
            case 'Rejected':
                return 'legal-doc-badge--danger';
            default:
                return 'legal-doc-badge--neutral';
        }
    }

    public toggleLegalCard(card: LegalDocCard): void {
        // While any card is in edit mode, require an explicit Save/Cancel before
        // expanding/collapsing other cards so edit state can't become orphaned.
        if (this.editingLegalCardKey) {
            return;
        }
        this.expandedLegalCardKey = this.expandedLegalCardKey === card.key ? null : card.key;
    }

    public startEditLegalCard(card: LegalDocCard, event?: Event): void {
        event?.stopPropagation();
        if (!this.canEditLegalDocuments) {
            this.messageService.add({ severity: 'warn', summary: 'Not allowed', detail: 'You do not have permission to edit documents.' });
            return;
        }
        if (!card.editFields || card.editFields.length === 0) {
            return;
        }
        if (!this.riderApplicationDetails) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Application details are not loaded yet.' });
            return;
        }
        const ad = this.riderApplicationDetails;
        const vehicle = this.getLegalActiveVehicle();
        card.newFiles = [];
        card.removedFileIds = [];
        card.edit = {
            licenseNumber: ad.DriverLicenseNumber ?? '',
            licenseType: ad.DriverLicenseType ?? XpressDocumentTypeEnum.DriverLicenseProfessional,
            licenseExpiry: this.driverLicenseExpirationDate ? new Date(this.driverLicenseExpirationDate) : null,
            nbiValidUntil: this.nbiExpirationDate ? new Date(this.nbiExpirationDate) : null,
            plate: ad.OrCrPlateNumber ?? vehicle?.NumberPlate ?? '',
            brandId: ad.VehicleBrandId ?? null,
            modelId: ad.VehicleModelId ?? null,
            orCrExpiry: this.orCrExpirationDate ? new Date(this.orCrExpirationDate) : null,
            color: ad.VehicleColor ?? null,
            paCpcType: ad.PaCpcType ?? XpressDocumentTypeEnum.Pa,
            paCpcCaseNumber: ad.PaCpcCaseNumber ?? '',
            paCpcExpiry: this.paCpcExpirationDate ? new Date(this.paCpcExpirationDate) : null,
            ridesharingAppId: ad.RidesharingAppId ?? null,
            tinNumber: ad.TinNumber ?? '',
            tinRegisteredName: ad.TinRegisteredName ?? ''
        };
        this.expandedLegalCardKey = card.key;
        this.editingLegalCardKey = card.key;

        if (card.key === 'orcr') {
            this.loadVehicleBrandModels();
            this.loadVehicleModelsForBrand(card.edit.brandId);
        }
    }

    public cancelEditLegalCard(card: LegalDocCard): void {
        card.newFiles = [];
        card.removedFileIds = [];
        this.editingLegalCardKey = null;

        // Rebuild now that editing is over: data that arrived while editing (e.g. a completing
        // getRiderVehicles) was skipped because buildLegalDocumentCards bails out during edit, so
        // OR/CR and vehicle photo cards could still show placeholder make/model/plate otherwise.
        this.buildLegalDocumentCards();
    }

    public onLegalCardFilesSelected(event: any, card: LegalDocCard): void {
        const raw = event?.target?.files ? Array.from(event.target.files) : Array.from(event ?? []);
        const maxFileSize = 8 * 1024 * 1024;

        const invalidType: string[] = [];
        const tooLarge: string[] = [];
        const accepted = (raw as File[]).filter((file: File) => {
            if (!SignupParams.ACCEPTED_FILE_TYPES.includes(file.type)) {
                invalidType.push(file.name);
                return false;
            }
            if (file.size > maxFileSize) {
                tooLarge.push(file.name);
                return false;
            }
            return true;
        });

        const existing = card.newFiles ?? [];
        const merged = [...existing];
        accepted.forEach((file: File) => {
            const isDuplicate = merged.some((f: File) =>
                f.name === file.name && f.size === file.size && f.lastModified === file.lastModified);
            if (!isDuplicate) {
                merged.push(file);
            }
        });

        const droppedForLimit = Math.max(0, merged.length - SignupParams.MAX_UPLOAD_FILES_COUNT);
        card.newFiles = merged.slice(0, SignupParams.MAX_UPLOAD_FILES_COUNT);
        if (event?.target) {
            event.target.value = '';
        }

        if (invalidType.length > 0) {
            this.messageService.add({ severity: 'warn', summary: 'Unsupported file type',
                detail: `Only JPG, PNG or PDF files are allowed. Skipped: ${invalidType.join(', ')}` });
        }
        if (tooLarge.length > 0) {
            this.messageService.add({ severity: 'warn', summary: 'File too large',
                detail: `Each file must be 8MB or less. Skipped: ${tooLarge.join(', ')}` });
        }
        if (droppedForLimit > 0) {
            this.messageService.add({ severity: 'warn', summary: 'Upload limit reached',
                detail: `You can attach up to ${SignupParams.MAX_UPLOAD_FILES_COUNT} files. ${droppedForLimit} file(s) were not added.` });
        }
    }

    public toggleRemoveLegalFile(card: LegalDocCard, file: LegalDocFile, event?: Event): void {
        event?.stopPropagation();
        if (!file.fileId) {
            return;
        }
        const idx = card.removedFileIds.indexOf(file.fileId);
        if (idx >= 0) {
            card.removedFileIds.splice(idx, 1);
        } else {
            card.removedFileIds.push(file.fileId);
        }
    }

    public isLegalFileMarkedToRemove(card: LegalDocCard, file: LegalDocFile): boolean {
        return !!file.fileId && card.removedFileIds.includes(file.fileId);
    }

    public openLegalCardFilePicker(inputId: string): void {
        document.getElementById(inputId)?.click();
    }

    public async saveLegalCard(card: LegalDocCard): Promise<void> {
        if (this.savingLegalCardKey) {
            return;
        }

        if (!this.canEditLegalDocuments) {
            this.messageService.add({ severity: 'warn', summary: 'Not allowed', detail: 'You do not have permission to edit documents.' });
            return;
        }

        const ad = this.riderApplicationDetails;
        if (!ad) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Application details are not loaded yet.' });
            return;
        }

        if (card.key === 'tinNumber') {
            const encodedTinNumber = String(card.edit.tinNumber ?? '').trim();
            const encodedTinRegisteredName = String(card.edit.tinRegisteredName ?? '').trim();
            if (!encodedTinNumber || !encodedTinRegisteredName) {
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: 'Encode TIN Number and Registered Name before updating the TIN requirement.'
                });
                return;
            }
        }

        this.savingLegalCardKey = card.key;

        let vehicle = this.getLegalActiveVehicle();
        if (!vehicle?.RiderVehicleId) {
            await this.getRiderVehicles();
            vehicle = this.getLegalActiveVehicle();
        }
        if (!vehicle?.RiderVehicleId) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Unable to resolve vehicle for this rider.' });
            this.savingLegalCardKey = null;
            return;
        }

        const fmtDate = (d: Date | string | null | undefined) => (d ? moment(d).format('YYYY-MM-DD') : null);

        const driverLicenseNumber = card.key === 'license' ? card.edit.licenseNumber : ad.DriverLicenseNumber;
        const driverLicenseType = card.key === 'license' ? card.edit.licenseType : ad.DriverLicenseType;
        const driverLicenseExpiry = card.key === 'license' ? card.edit.licenseExpiry : this.driverLicenseExpirationDate;
        const nbiExpiry = card.key === 'nbi' ? card.edit.nbiValidUntil : this.nbiExpirationDate;
        const orCrPlate = card.key === 'orcr' ? card.edit.plate : ad.OrCrPlateNumber;
        const orCrExpiry = card.key === 'orcr' ? card.edit.orCrExpiry : this.orCrExpirationDate;
        const vehicleColor = card.key === 'vehiclePhotos' && card.edit.color != null ? card.edit.color : ad.VehicleColor;
        const paCpcType = card.key === 'pacpc' ? card.edit.paCpcType : ad.PaCpcType;
        const paCpcCaseNumber = card.key === 'pacpc' ? card.edit.paCpcCaseNumber : ad.PaCpcCaseNumber;
        const paCpcExpiry = card.key === 'pacpc' ? card.edit.paCpcExpiry : this.paCpcExpirationDate;
        const ridesharingAppId = card.key === 'previousExperience' ? card.edit.ridesharingAppId : ad.RidesharingAppId;
        const tinNumber = card.key === 'tinNumber' ? card.edit.tinNumber : ad.TinNumber;
        const tinRegisteredName = card.key === 'tinNumber' ? card.edit.tinRegisteredName : ad.TinRegisteredName;

        const formData = new FormData();
        this.appendIfExists('RiderId', this.driverId, formData);
        this.appendIfExists('RiderVehicleId', vehicle.RiderVehicleId, formData);
        this.appendIfExists('ServiceType', ad.ServiceType, formData);
        this.appendIfExists('TransportationType', ad.TransportationType, formData);
        this.appendIfExists('VehicleType', ad.VehicleType, formData);
        this.appendIfExists('VehicleYear', ad.VehicleYear, formData);
        this.appendIfExists('VehicleColor', vehicleColor, formData);

        if (card.key === 'orcr') {
            this.appendIfExists('VehicleBrandId', card.edit.brandId, formData);
            this.appendIfExists('VehicleModelId', card.edit.modelId, formData);
        } else {
            this.appendIfExists('VehicleBrandId', ad.VehicleBrandId, formData);
            this.appendIfExists('VehicleModelId', ad.VehicleModelId, formData);
        }

        this.appendIfExists('DriverLicenseNumber', driverLicenseNumber, formData);
        this.appendIfExists('DriverLicenseType', driverLicenseType, formData);
        this.appendIfExists('DriverLicenseExpirationDate', fmtDate(driverLicenseExpiry), formData);
        this.appendIfExists('NbiExpirationDate', fmtDate(nbiExpiry), formData);
        // Keep clearance slot aligned with the card being edited (NBI vs Police).
        if (card.key === 'nbi') {
            const clearanceType = card.checkType === LegalDocVerificationCheck.PoliceClearance
                ? XpressDocumentTypeEnum.PoliceClearance
                : XpressDocumentTypeEnum.NBIClearance;
            this.appendIfExists('ClearanceType', clearanceType, formData);
        } else if (ad.ClearanceType != null) {
            this.appendIfExists('ClearanceType', ad.ClearanceType, formData);
        }
        this.appendIfExists('OrCrPlateNumber', orCrPlate, formData);
        this.appendIfExists('OrCrChassisNumber', ad.OrCrChassisNumber, formData);
        this.appendIfExists('OrCrEngineNumber', ad.OrCrEngineNumber, formData);
        this.appendIfExists('OrCrOwnerFirstName', ad.OrCrOwnerFirstName, formData);
        this.appendIfExists('OrCrOwnerLastName', ad.OrCrOwnerLastName, formData);
        this.appendIfExists('OrCrExpirationDate', fmtDate(orCrExpiry), formData);
        this.appendIfExists('PaCpcType', paCpcType, formData);
        this.appendIfExists('PaCpcCaseNumber', paCpcCaseNumber, formData);
        this.appendIfExists('PaCpcOperatorName', ad.PaCpcOperatorName, formData);
        this.appendIfExists('PaCpcExpirationDate', fmtDate(paCpcExpiry), formData);
        this.appendIfExists('PreviousExperience', ad.PreviousExperience, formData);
        this.appendIfExists('RidesharingAppId', ridesharingAppId, formData);
        this.appendIfExists('TinNumber', tinNumber, formData);
        this.appendIfExists('TinRegisteredName', tinRegisteredName, formData);

        this.appendIfExists('DocumentUpdates[0].DocumentType', card.checkType, formData);
        if (card.checkType != null) {
            this.appendIfExists('DocumentUpdates[0].DocumentStatus', XpressRiderDocumentVerificationStatusEnum.Approved, formData);
        }
        card.newFiles.forEach((file: File) => {
            this.appendIfExists('DocumentUpdates[0].DocumentFiles', file, formData);
        });

        card.removedFileIds.forEach((fileId: number, index: number) => {
            this.appendIfExists(`FileIdsToRemove[${index}]`, fileId, formData);
        });

        try {
            const result = await this.riderService.updateRiderInfoV2(formData, this.messageService);
            if (!result || !result.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: result?.ErrorMessage || 'Failed to update document.' });
                return;
            }

            if (result.ErrorMessage) {
                this.messageService.add({ severity: 'warn', summary: 'Partial Success', detail: result.ErrorMessage });
            } else {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Document updated successfully.' });
            }

            this.editingLegalCardKey = null;
            await this.loadRiderApplicationDetails();
            // Refresh the vehicle cache too: OR/CR detail rows read make/model/plate from the
            // active vehicle, so without this an OR/CR edit saves correctly yet the expanded card
            // keeps showing the previous make/model until something else triggers getRiderVehicles.
            await this.getRiderVehicles();
            this.updateCarouselImages();
        } finally {
            this.savingLegalCardKey = null;
        }
    }
    //end legal documents cards

    private appendIfExists(key: string, value: any, formData: FormData): FormData {
        if (value != null && value !== '') {
            formData.append(key, value);
        }
        return formData;
    }

    //start training galleria
    public infoTrainingItems: any = [];
    public activeTrainingImgIndex: number = 0;
    public displayTrainingImg: boolean = false;

    public showDriverTrainingImageModal(index: number) {
        this.infoTrainingItems = [{ value: this.driverTrainings[index].File }];
        this.displayTrainingImg = true;
    }
    //end training galleria

    public getTrainingResultStyles(status: any): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status) {
            case TrainingResultEnum.Passed:
                backgroundColor = '#1CBA70';
                textColor = '#FFF';
                break;
            case TrainingResultEnum.Failed:
                backgroundColor = '#EB4236';
                textColor = '#FFF';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    public getStatusStyles(status: any): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (status) {
            case DriverDetailOrderStatusEnum.Completed:
                backgroundColor = '#1CBA70';
                textColor = '#FFF';
                break;
            case DriverDetailOrderStatusEnum.Cancelled:
            case DriverDetailOrderStatusEnum.DriverCancelled:
                backgroundColor = '#EB4236';
                textColor = '#FFF';
                break;
            case DriverDetailOrderStatusEnum.Rejected:
                backgroundColor = '#FF6347';
                textColor = '#FFF';
                break;
            case DriverDetailOrderStatusEnum.CustomerCancelled:
                backgroundColor = '#FFC043';
                textColor = '#664D1B';
                break;
            case DriverDetailOrderStatusEnum.AdminCancelled:
                backgroundColor = '#333333';
                textColor = '#FFF';
                break;
            case BookingStatus.Requesting:
                backgroundColor = '#FFC043';
                textColor = '#004060';
                break;
            case BookingStatus.PickingUp:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case BookingStatus.Arrived:
                backgroundColor = '#0A84FF';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.WaitingForPassenger:
                backgroundColor = '#F77F00';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.WaitingExtended:
                backgroundColor = '#A53D27';
                textColor = '#FFFFFF';
                break;
            case BookingStatus.Canceled:
                backgroundColor = '#EB4236';
                textColor = '#FDEBEA';
                break;
            case BookingStatus.Assigned:
                backgroundColor = '#A1BDCA';
                textColor = '#004060';
                break;
            case BookingStatus.OnTrip:
                backgroundColor = '#0A84FF';
                textColor = '#FFFFFF';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    public getFontColor(status: string): FontColorStatus {
        let textColor: string;
        switch (status) {
            case WalletCommerceTransactions.Paid:
                textColor = '#1CBA70';
                break;
            case WalletCommerceTransactions.Failed:
                textColor = '#F77F00';
                break;
            case WalletCommerceTransactions.Overdue:
                textColor = '#EB1D25';
                break;
            case WalletCommerceTransactions.Penalty:
                textColor = '#0A84FF';
                break;
            default:
                textColor = '';
        }

        return {
            color: textColor
        };
    }

    private initDriverCampaignList() {
        if (this.appData.isBoracayLocation) {
            this.driverCampaignList = [
                { id: DriverCampaignType.Boracay, name: 'Boracay Campaign' },
                { id: DriverCampaignType.LoopPassCampaign, name: 'Loop Pass Campaign' },
            ];
        }
        else if (this.menuPermissionActive && this.menuPermissionActive.includes(MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_2W)) {
            this.driverCampaignList = [
                { id: DriverCampaignType.CampaignDriver, name: 'Campaign Driver' },
                { id: DriverCampaignType.Xpress50, name: 'Xpress 50' },
				{ id: DriverCampaignType.Xpress2WEV, name: '2W EV' },
				{ id: DriverCampaignType.Xpress4WEVBataan, name: 'Bataan Full-EV Drivers' }
            ];
        }
        else if (this.menuPermissionActive && this.menuPermissionActive.includes(MenuPermissionConfig.BACK_OFFICE_DRIVERS_PASSENGER_4W)) {
            this.driverCampaignList = [
                {
                    id: DriverCampaignType.Xpress50Rider4W, name: 'Xpress 50 4W',
                    incentiveTypes: [
                        { id: Xpress50IncentiveType.Morning, name: 'AM' },
                        { id: Xpress50IncentiveType.Evening, name: 'PM' },
                    ]
                },
                { id: DriverCampaignType.PriorityOrders, name: 'Priority Orders' },
                { id: DriverCampaignType.Xpress4WEV, name: '4W EV' },
                { id: DriverCampaignType.AllanGroup, name: 'Allan Group' },
				{ id: DriverCampaignType.NiloGroup, name: 'Nilo Group' },
				{ id: DriverCampaignType.Xpress4WEVBataan, name: 'Bataan Full-EV Drivers' }
            ];
        }
        else {
            this.driverCampaignList = [
                { id: DriverCampaignType.CampaignDriver, name: 'Campaign Driver' },
				{ id: DriverCampaignType.Xpress50, name: 'Xpress 50' },
				{ id: DriverCampaignType.Xpress4WEVBataan, name: 'Bataan Full-EV Drivers' }
            ];
        }
    }

    addToCampaign() {
        if (!this.selectedCampaign) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a campaign' });
            return;
        }

        if (this.selectedCampaign === DriverCampaignType.Xpress50Rider4W && !this.selectedXpress50IncentiveType) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select an incentive type' });
            return;
        }

        const dto = {
            RiderId: this.driverId,
            IsLoopPassCampaign: (this.selectedCampaign === DriverCampaignType.LoopPassCampaign) ? true : null,
            IsBelongCompany: (this.selectedCampaign === DriverCampaignType.CampaignDriver) ? true : null,
            IsBelongXpress50: (this.selectedCampaign === DriverCampaignType.Xpress50) ? true : null,
            AssignedToBoracayCampaign: (this.selectedCampaign === DriverCampaignType.Boracay) ? true : null,
            IsXpress50Rider4W: (this.selectedCampaign === DriverCampaignType.Xpress50Rider4W) ? true : null,
            PriorityOrders: (this.selectedCampaign === DriverCampaignType.PriorityOrders) ? true : null,
            IsEVDriver: (this.selectedCampaign === DriverCampaignType.Xpress2WEV || this.selectedCampaign === DriverCampaignType.Xpress4WEV) ? true : null,
            IsAllanGroup: (this.selectedCampaign === DriverCampaignType.AllanGroup) ? true : null,
            IsNiloGroup: (this.selectedCampaign === DriverCampaignType.NiloGroup) ? true : null,
			Xpress50IncentiveType: this.selectedXpress50IncentiveType, // Only for 4W am/pm
			IsXpress4WEVBataan: (this.selectedCampaign === DriverCampaignType.Xpress4WEVBataan) ? true : null
        };
        this.addOrRemoveRiderCampaign(dto, 'Rider added in to campaign');
    }

    removeFromCampaign() {
        if (!this.selectedCampaign) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please select a campaign' });
            return;
        }

        const dto = {
            RiderId: this.driverId,
            IsBelongCompany: (this.selectedCampaign === DriverCampaignType.CampaignDriver) ? false : null,
            IsBelongXpress50: (this.selectedCampaign === DriverCampaignType.Xpress50) ? false : null,
            AssignedToBoracayCampaign: (this.selectedCampaign === DriverCampaignType.Boracay) ? false : null,
            IsXpress50Rider4W: (this.selectedCampaign === DriverCampaignType.Xpress50Rider4W) ? false : null,
            IsEVDriver: (this.selectedCampaign === DriverCampaignType.Xpress2WEV || this.selectedCampaign === DriverCampaignType.Xpress4WEV) ? false : null,
            IsAllanGroup: (this.selectedCampaign === DriverCampaignType.AllanGroup) ? false : null,
            IsNiloGroup: (this.selectedCampaign === DriverCampaignType.NiloGroup) ? false : null,
            IsLoopPassCampaign: (this.selectedCampaign === DriverCampaignType.LoopPassCampaign) ? false : null,
			PriorityOrders: (this.selectedCampaign === DriverCampaignType.PriorityOrders) ? false : null,
			IsXpress4WEVBataan: (this.selectedCampaign === DriverCampaignType.Xpress4WEVBataan) ? false : null
        };
        this.addOrRemoveRiderCampaign(dto, 'Rider removed from campaign');
        this.removeCampaignFromUI();
    }

    addOrRemoveRiderCampaign(dto: any, successMessage: string) {
        this.riderService.addOrRemoveRiderCampaign(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: successMessage });
                this.selectedCampaign = null;
            });

    }

    getIncentiveType(incentiveType: Xpress50IncentiveType) {
        let result = '';
        if (this.driver?.IsXpress50Rider4W) {
            result = 'Xpress 50 4W ';
        }
        switch (incentiveType) {
            case Xpress50IncentiveType.None: result += 'None'; break;
            case Xpress50IncentiveType.Morning: result += 'AM'; break;
            case Xpress50IncentiveType.Evening: result += 'PM'; break;
            default: return '';
        }

        return result;
    }

    addCampaign(campaignName: any) {
        if (!campaignName) { return; }
        switch (campaignName) {
            case 'Loop Pass Campaign':
                this.selectedCampaign = DriverCampaignType.LoopPassCampaign;
                this.driver.IsLoopPassCampaign = true;
                break;
            case 'Campaign Driver':
                this.selectedCampaign = DriverCampaignType.CampaignDriver;
                this.driver.IsBelongCompany = true;
                break;
            case 'Xpress 50':
                this.selectedCampaign = DriverCampaignType.Xpress50;
                this.driver.IsBelongXpress50 = true;
                break;
            case '2W EV':
                this.selectedCampaign = DriverCampaignType.Xpress2WEV;
                this.driver.IsEVDriver = true;
                break;
            case '4W EV':
                this.selectedCampaign = DriverCampaignType.Xpress4WEV;
                this.driver.IsEVDriver = true;
                break;
            case 'Allan Group':
                this.selectedCampaign = DriverCampaignType.AllanGroup;
                this.driver.IsAllanGroup = true;
                break;
            case 'Nilo Group':
                this.selectedCampaign = DriverCampaignType.NiloGroup;
                this.driver.IsNiloGroup = true;
                break;
            case 'Priority Orders':
                this.selectedCampaign = DriverCampaignType.PriorityOrders;
                this.driver.PriorityOrders = true;
                break;
            case 'AM':
                this.selectedCampaign = DriverCampaignType.Xpress50Rider4W;
                this.driver.IsXpress50Rider4W = true;
                this.selectedXpress50IncentiveType = Xpress50IncentiveType.Morning;
                this.driver.Xpress50IncentiveType = this.selectedXpress50IncentiveType;
                break;
            case 'PM':
                this.selectedCampaign = DriverCampaignType.Xpress50Rider4W;
                this.driver.IsXpress50Rider4W = true;
                this.selectedXpress50IncentiveType = Xpress50IncentiveType.Evening;
                this.driver.Xpress50IncentiveType = this.selectedXpress50IncentiveType;
				break;
			case 'Bataan Full-EV Drivers':
				this.selectedCampaign = DriverCampaignType.Xpress4WEVBataan;
				this.driver.IsXpress4WEVBataan = true;
				break;
        }

        this.addToCampaign();
    }

    hasAnyCampaigns(driver: any): boolean {
        if (!driver) {
            return false;
		}
        return driver.IsBelongCompany ||
            driver.IsBelongXpress50 ||
            driver.AssignedToBoracayCampaign ||
            driver.IsXpress50Rider4W ||
            driver.PriorityOrders ||
            driver.IsEVDriver ||
            driver.IsPromoBYDGroup ||
			driver.IsLoopPassCampaign ||
			driver.IsXpress4WEVBataan;
    }

    removeCampaign(campaignType: DriverCampaignType) {
        this.selectedCampaign = campaignType;
        this.removeFromCampaign();
    }

    removeCampaignFromUI() {
        switch (this.selectedCampaign) {
            case DriverCampaignType.CampaignDriver:
                this.driver.IsBelongCompany = false;
                break;
            case DriverCampaignType.Xpress50:
                this.driver.IsBelongXpress50 = false;
                break;
            case DriverCampaignType.Boracay:
                this.driver.AssignedToBoracayCampaign = false;
                break;
            case DriverCampaignType.PriorityOrders:
                this.driver.PriorityOrders = false;
                break;
            case DriverCampaignType.Xpress50Rider4W:
                this.driver.IsXpress50Rider4W = false;
                this.selectedXpress50IncentiveType = null;
                break;
            case DriverCampaignType.Xpress2WEV:
            case DriverCampaignType.Xpress4WEV:
                this.driver.IsEVDriver = false;
                break;
            case DriverCampaignType.AllanGroup:
                this.driver.IsAllanGroup = false;
                break;
            case DriverCampaignType.NiloGroup:
                this.driver.IsNiloGroup = false;
                break;
            case DriverCampaignType.LoopPassCampaign:
                this.driver.IsLoopPassCampaign = false;
                break;
        }
    }

    scheduleTraining() {
        //TODO after specs available
    }

    showVehicleDetails(vehicle: any) {
        this.selectedVehicle = vehicle;
        if (this.isOperator) {
            this.infoItems = [
                { value: this.selectedVehicle?.VehicleFrontImageUrl},{value: this.selectedVehicle?.VehicleBackImageUrl},
                { value: this.selectedVehicle?.VehicleRightSideImageUrl},{value: this.selectedVehicle?.VehicleLeftSideImageUrl},
            ];
            this.showVehicleDetailsInfo = true;
        } else {
            this.showVehicleDetailsSidebar = true;
        }
    }

    closeVehicleDetails() {
        this.showVehicleDetailsInfo = false;
    }

    closeVehicleDetailSideBar() {
        this.showVehicleDetailsSidebar = false;
    }

    openEditVehicleModal() {
        this.showEditVehicleModal = true;
    }

    async onVehicleSaved(data?: any) {
        await this.getRiderVehicles();
        if (this.selectedVehicle?.RiderVehicleId) {
            const updatedVehicle = this.vehicles.find((v: any) => v.RiderVehicleId === this.selectedVehicle?.RiderVehicleId);
            if (updatedVehicle) {
                this.selectedVehicle = { ...updatedVehicle };
            }
        }
    }

    public getServiceTypeIcon(service: string): string {
        const tmp = service.split(' ');
        if (tmp && tmp.length === 3) {
            return tmp[2].toLowerCase();
        }
        return '';
    }

    updateDriverStats(datesFilter: any) {
        if (this.isActiveDrivers) {
            this.selectedDateRange[0] = datesFilter.startDate;
            this.selectedDateRange[1] = datesFilter.endDate;
            this.getRiderStatistics();
        }
    }

    updateWalletStats(datesFilter: any) {
        if (this.isActiveDrivers) {
            this.selectedDateRange[0] = datesFilter.startDate;
            this.selectedDateRange[1] = datesFilter.endDate;
            this.getRiderTransactions();
        }
    }

    updateAppHistory(datesFilter: any) {
        if (this.isActiveDrivers) {
            this.selectedDateRange[0] = datesFilter.startDate;
            this.selectedDateRange[1] = datesFilter.endDate;
            this.getHistoryRiderAvailabilities();
            this.getRiderLocationHistory();
        }
    }

    filterBookings(datesFilter: any) {
        if (this.isActiveDrivers) {
            this.selectedDateRange[0] = datesFilter.startDate;
            this.selectedDateRange[1] = datesFilter.endDate;
            this.getRiderDeliveryOrders(0);
        }
    }

    filterTrainings(datesFilter: any) {
        if (this.isActiveDrivers) {
            this.selectedDateRange[0] = datesFilter.startDate;
            this.selectedDateRange[1] = datesFilter.endDate;
            this.getRiderTrainings(0);
        }
    }

    public addVehicleTypeInToList() {
        if (this.appData.isBoracayLocation) {
            this.vehicleTypeList = [
                {
                    name: 'Charter | E-Trike',
                    value: RiderVehicleTypeEnum.ETrike
                },
                {
                    name: 'Charter | Van',
                    value: RiderVehicleTypeEnum.Van
                },
                {
                    name: 'Charter | Minibus',
                    value: RiderVehicleTypeEnum.Minibus
                },
                {
                    name: 'Charter | Multicab',
                    value: RiderVehicleTypeEnum.Multicab
                }
            ];
        } else {
            this.vehicleTypeList = [
                {
                    name: 'Ride',
                    value: RiderVehicleTypeEnum.Moto
                },
                {
                    name: 'Eats',
                    value: RiderVehicleTypeEnum.Food
                },
                {
                    name: 'Mart',
                    value: RiderVehicleTypeEnum.Grocery
                },
                {
                    name: 'Send',
                    value: RiderVehicleTypeEnum.Courier
                }
            ];
        }
    }

    public sendUpdatePush() {
        const dto = {
            RiderId: this.driverId
        };
        this.riderService.sendUpdatePush(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Push notification sent to driver successfully!' });
            });
    }

    showCampaignDialog(riderObj: any) {
        this.driverId = riderObj.XpressRiderId;
        this.visibleCampaignDialog = true;
    }


    private resolveCompensationServiceTypeId(): number {
        const riderType = this.driver?.RiderType;
        if (riderType === DriverTypeEnum.Taxi) {
            return ServiceTypeEnum.Taxi;
        }
        if (riderType === DriverTypeEnum.Connex) {
            return ServiceTypeEnum.Connex;
        }
        return ServiceTypeEnum.Ride;
    }

    public get earningTypeBadgeText(): string {
        return (this.compensationProfile?.Name || '').trim();
    }

    // scoped to active, non-salaried Passenger 4W Ride/TNVS drivers. Require the vehicle being
    // edited here to be that same active vehicle before allowing the Sedan/SUV correction UI.
    public get canEditVehicleType(): boolean {
        return !!this.driver?.CanEditVehicleType
            && !!this.selectedVehicle
            && this.selectedVehicle.IsActive === true
            && this.selectedVehicle.VehicleTypeId === this.driver?.VehicleTypeId;
    }

    public get canSaveEarningTypeChanges(): boolean {
        return this.canEditVehicles && this.hasPendingEarningTypeChanges && !this.isEarningTypeUpdating;
    }

    public get canDiscardEarningTypeChanges(): boolean {
        return this.hasPendingEarningTypeChanges && !this.isEarningTypeUpdating;
    }

    public get driverDisplayName(): string {
        const fullName = `${this.driver?.FirstName || ''} ${this.driver?.LastName || ''}`.trim();
        return fullName || this.driver?.UserName || 'this driver';
    }

    public get earningTypeSelectionLabel(): string {
        return this.isSalariedEarningType ? 'salaried' : 'non-salaried';
    }

    public get earningTypeSavedLabel(): string {
        return this.savedIsSalariedEarningType ? 'salaried' : 'non-salaried';
    }

    public get earningTypeConfirmationPrefix(): string {
        if (!this.hasSavedEarningTypeAssignment) {
            return `Set ${this.driverDisplayName} to `;
        }

        return `Change ${this.driverDisplayName} from `;
    }

    public get earningTypeConfirmationFromLabel(): string {
        if (!this.hasSavedEarningTypeAssignment) {
            return '';
        }

        return this.earningTypeSavedLabel;
    }

    public get earningTypeConfirmationToLabel(): string {
        return `${this.earningTypeSelectionLabel}?`;
    }

    public get earningTypeConfirmationTitle(): string {
        return this.isSalariedEarningType
            ? 'Salaried wallet behavior applies immediately.'
            : 'Non-salaried wallet behavior applies immediately.';
    }

    public get earningTypeConfirmationText(): string {
        return this.isSalariedEarningType
            ? 'Salaried drivers draw from security wallet. The preserved commission assignment remains editable but inactive while salaried.'
            : 'Normal commission-profile resolution resumes using direct assignment, then group profile, then area default.';
    }

    public get xpressShareText(): string {
        if (this.isSalariedEarningType) {
            return '';
        }
        const percent = this.compensationProfile?.CommissionPercentage;
        if (percent === null || percent === undefined || percent === '') {
            return '';
        }
        const numeric = Number(percent);
        if (Number.isNaN(numeric)) {
            return '';
        }
        const rounded = Number.isInteger(numeric) ? numeric.toFixed(0) : String(numeric);
        return `${rounded}%`;
    }

    public get walletTopUpText(): string {
        const amount = this.driver?.ActivationWalletTopUpAmount;
        if (amount === null || amount === undefined || amount === '') {
            return '';
        }
        const numeric = Number(amount);
        if (!numeric) {
            return '';
        }
        return `₱${numeric.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }

    public get scheduledActivationText(): string {
        const activationDate = this.driver?.ActivationDate;
        if (!activationDate) {
            return '';
        }
        const local = moment.utc(activationDate).local();
        return local.isValid() ? local.format('MMM D, YYYY, h:mm A') : '';
    }

    public get showActivationSummary(): boolean {
        return !!(this.xpressShareText || this.walletTopUpText || this.scheduledActivationText);
    }

    public get earningTypePanelTitle(): string {
        return this.isSalariedEarningType
            ? 'Salaried wallet behavior applies immediately.'
            : 'Non-salaried wallet behavior applies immediately.';
    }

	public get earningTypePanelText(): string {
		return this.isSalariedEarningType
			? 'Salaried drivers draw from security wallet. Any commission profile below is preserved, editable, '
			+ 'and inactive while salaried. Transaction mechanics are handled by the owning payments / '
			+ 'driver-app teams.'
			: 'Normal commission-profile resolution resumes using direct assignment, then group profile, then area default.';
	}

    private syncEarningTypeState(isSalaried: boolean, hasSavedAssignment: boolean): void {
        this.isSalariedEarningType = isSalaried;
        this.savedIsSalariedEarningType = isSalaried;
        this.hasSavedEarningTypeAssignment = hasSavedAssignment;
        this.hasPendingEarningTypeChanges = false;
        this.earningTypeConfirmDialog = false;
    }

    private revertPendingEarningTypeChanges(): void {
        this.isSalariedEarningType = this.savedIsSalariedEarningType;
        this.hasPendingEarningTypeChanges = false;
    }

    private applyCompensationProfile(data: any): void {
        this.compensationProfile = data?.Profile ?? null;
        this.compensationProfileError = null;
        let isSalaried = false;
        const compensationType = this.compensationProfile?.CompensationType;
        isSalaried = compensationType === 2 || compensationType === 3; // SalaryOnly | SalaryPlusCommission
        const isPlatformFeeShare = compensationType === 5;
        this.isEarningTypeLocked =
            this.driver?.RiderType === DriverTypeEnum.Taxi ||
            this.driver?.RiderType === DriverTypeEnum.Connex ||
            isPlatformFeeShare;
        if (this.isEarningTypeLocked && !isPlatformFeeShare) {
            isSalaried = true;
        }
        this.syncEarningTypeState(isSalaried, !!this.compensationProfile);
    }

    public async loadRiderCompensationProfile(): Promise<void> {
        if (!this.isActiveDrivers || !this.driverId || this.isOperator) {
            this.compensationProfile = null;
            this.compensationProfileError = null;
            this.syncEarningTypeState(false, false);
            this.isEarningTypeLocked = false;
            return;
        }

        const previousSavedSalaried = this.savedIsSalariedEarningType;
        const previousHasSavedAssignment = this.hasSavedEarningTypeAssignment;
        const previousProfile = this.compensationProfile;
        this.compensationProfileError = null;
        this.isEarningTypeLocked =
            this.driver?.RiderType === DriverTypeEnum.Taxi ||
            this.driver?.RiderType === DriverTypeEnum.Connex;

        const dto = {
            RiderId: this.driverId,
            ServiceTypeId: this.resolveCompensationServiceTypeId()
        };

        try {
            const data = await this.riderService.getRiderCompensationProfile(dto, this.messageService);
            if (!data?.Success) {
                this.compensationProfile = null;
                this.compensationProfileError = data?.ErrorMessage
                    || 'No active commission profile. Choose earning type to assign one.';
                // Keep toggle usable; preserve last known earning type after a successful save
                // if reload cannot find the assignment yet.
                if (this.isEarningTypeLocked) {
                    this.syncEarningTypeState(true, true);
                } else {
                    this.syncEarningTypeState(previousSavedSalaried, previousHasSavedAssignment);
                }
                return;
            }
            this.applyCompensationProfile(data);
        } catch {
            this.compensationProfileError = 'Failed to load commission profile';
            if (previousProfile) {
                this.compensationProfile = previousProfile;
                this.syncEarningTypeState(previousSavedSalaried, previousHasSavedAssignment);
            } else if (this.isEarningTypeLocked) {
                this.syncEarningTypeState(true, true);
            } else {
                this.syncEarningTypeState(previousSavedSalaried, previousHasSavedAssignment);
            }
        }
    }

    public onEarningTypeChange(isSalaried: boolean): void {
        if (this.isEarningTypeUpdating) {
            return;
        }
        if (!this.canEditVehicles) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Not allowed',
                detail: 'You do not have permission to edit earning type.'
            });
            return;
        }
        if (this.isEarningTypeLocked && !isSalaried) {
            return;
        }
        if (isSalaried === this.isSalariedEarningType && this.hasPendingEarningTypeChanges) {
            return;
        }

        this.isSalariedEarningType = isSalaried;
        this.hasPendingEarningTypeChanges =
            !this.hasSavedEarningTypeAssignment || this.savedIsSalariedEarningType !== isSalaried;
    }

    public discardEarningTypeChanges(): void {
        if (!this.canDiscardEarningTypeChanges) {
            return;
        }

        this.revertPendingEarningTypeChanges();
    }

    public openEarningTypeConfirmDialog(): void {
        if (!this.canSaveEarningTypeChanges) {
            return;
        }

        this.earningTypeConfirmDialog = true;
    }

    public cancelEarningTypeConfirmDialog(): void {
        this.earningTypeConfirmDialog = false;
        this.revertPendingEarningTypeChanges();
    }

    public async confirmEarningTypeChange(): Promise<void> {
        if (!this.canSaveEarningTypeChanges) {
            return;
        }

        const nextIsSalaried = this.isSalariedEarningType;
        const previousSavedSalaried = this.savedIsSalariedEarningType;
        const previousHasSavedAssignment = this.hasSavedEarningTypeAssignment;

        this.earningTypeConfirmDialog = false;
        this.isEarningTypeUpdating = true;

        try {
            const data = await this.riderService.updateRiderEarningType(
                { RiderId: this.driverId, IsSalaried: nextIsSalaried },
                this.messageService
            );
            if (!data?.Success) {
                this.savedIsSalariedEarningType = previousSavedSalaried;
                this.hasSavedEarningTypeAssignment = previousHasSavedAssignment;
                this.revertPendingEarningTypeChanges();
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error',
                    detail: data?.ErrorMessage || 'Failed to update earning type'
                });
                return;
            }

            this.savedIsSalariedEarningType = nextIsSalaried;
            this.hasSavedEarningTypeAssignment = true;
            this.hasPendingEarningTypeChanges = false;

            this.messageService.add({
                severity: 'success',
                summary: 'Saved!',
                detail: 'Earning type updated successfully.'
            });
            await this.loadRiderCompensationProfile();
        } catch {
            this.savedIsSalariedEarningType = previousSavedSalaried;
            this.hasSavedEarningTypeAssignment = previousHasSavedAssignment;
            this.revertPendingEarningTypeChanges();
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'Failed to update earning type'
            });
        } finally {
            this.isEarningTypeUpdating = false;
        }
    }

    public getRiderInfo() {
        this.resetLegalDocumentsState();
        const dto = {
            RiderId: this.driverId
        };
        this.riderService.getRiderInfo(dto, this.messageService)
            .then(async data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.driver = data;
                console.log(this.driver);
                if (!this.isActiveDrivers && !this.driver.Services.includes('Ride')) {
                    this.menuItems = this.menuItems.filter(m => m.id !== String(MenuTab.Commerce));
                }
                this.initialDriver = JSON.parse(JSON.stringify(this.driver));

                this.driver.ServicesTypes.forEach((item: any) => {
                    item.ServiceTypeImg = this.getServiceTypeImg(item.ServiceType);
                });
                this.driver.BirthDate = new Date(this.driver.BirthDate);
                this.driver.Operator = 'Xpress'; //TODO remove after operators enabled
                await this.loadRiderApplicationDetails();
                await this.loadRiderCompensationProfile();
                this.updateCarouselImages();

                // resetLegalDocumentsState cleared this.vehicles on the driver switch. If the user
                // is already on the Vehicles tab, refetch here so it doesn't show "Driver assignment
                // pending" for a rider that actually has vehicles. (When not in flight already from
                // buildLegalDocumentCards.)
                if (this.activeTab === MenuTab.Vehicles && !this.isVehicleSpinner) {
                    this.getRiderVehicles();
                }
            });

	}

	isDocExpired(docDate?: string | Date | null): boolean {
		if (!docDate) { return true; }

		const docTime = new Date(docDate).getTime();
		const now = new Date().getTime();

		return docTime <= now;
	}

	isDocExpiring(docDate?: Date | string | null): boolean {
		if (!docDate) {
			return true;
		}

		const expDate = new Date(docDate);
		const now = new Date();
		const soon = new Date();

		soon.setDate(now.getDate() + 30);

		return expDate >= now && expDate <= soon;
	}

	getDocStatus(...dates: (string | Date | null | undefined)[]): 'Expired' | 'Expiring' | 'Missing' | null {
		const validDates = dates.filter(d => !!d) as (string | Date)[];

		if (validDates.length === 0) {
			return 'Missing';
		}

		if (validDates.some(d => this.isDocExpired(d))) {
			return 'Expired';
		}

		if (validDates.some(d => this.isDocExpiring(d))) {
			return 'Expiring';
		}

		return null; // все даты валидны и далекие → скрываем
	}

    public updateRiderInfo() {
        const dto = {
            RiderId: this.driverId,
            ImageUrl: this.driver.ImageUrl,
            FirstName: this.driver.FirstName,
            LastName: this.driver.LastName,
            Gender: this.driver.Gender,
            Phone: this.driver.Phone,
            Email: this.driver.Email,
            BirthDate: moment(this.driver.BirthDate).format('YYYY-MM-DD')
        };
        if (!this.driver.FirstName || !this.driver.LastName || !this.driver.Gender || !this.driver.Phone || !this.driver.Email) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter First Name, Last Name, Gender, Phone and Email' });
            return;
        }
        this.riderService.updateRiderInfo(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Driver info updated' });
                this.getRiderInfo();
                this.showEditFields = false;
            });

    }

    public async getRiderVehicles() {
        this.isVehicleSpinner = true;

        const dto = {
            RiderId: this.driverId
        };
        try {
            const data = await this.riderService.getRiderVehicles(dto, this.messageService);
            if (!data.Success) {
                this.isVehicleSpinner = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.vehicles = (data.Items || [])
                .slice()
                .sort((a: any, b: any) => Number(!!b?.IsActive) - Number(!!a?.IsActive));
            this.vehicles.forEach((item: any) => {
                item.CreatedAt = moment(Utils.utcToLocalDate(item.CreatedAt)).format('MM/DD/YY');
                item.BoundaryFee = item.BoundaryFee != null ? '₱'+item.BoundaryFee : '';
                item.VehicleImages = [item.VehicleFrontImageUrl, item.VehicleBackImageUrl, item.VehicleRightSideImageUrl, item.VehicleLeftSideImageUrl];
            });
            this.isVehicleSpinner = false;

            if (this.riderApplicationDetails) {
                this.buildLegalDocumentCards();
            }
        } catch (err) {
            this.isVehicleSpinner = false;
            throw err;
        }
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.activeTab === MenuTab.History) {
            this.getHistoryRiderAvailabilities();
            this.getRiderLocationHistory();
        } else if (this.activeMenuFinanceTab === MenuFinanceTab.Payout) {
            this.getRiderInvoices(skip);
        } else if (this.activeTab === MenuTab.Orders) {
            this.getRiderDeliveryOrders(skip);
        }
    }
    public getRiderDeliveryOrders(skip: number) {
        this.isOrderSpinner = true;

        const dto = {
            RiderId: this.driverId,
            VehicleTypes: this.selectedRiderVehicleTypes,
            DeliveryStatuses: this.selectedDeliveryStatuses,
            CancelRoleId: this.cancelRoleIds,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            SearchName: this.filter.searchName,
            StartDate: (!this.selectedDateRange) ? null : (!this.selectedDateRange[0]) ? null : moment(this.selectedDateRange[0]).format('YYYY-MM-DDTHH:mm:ss'),
            EndDate: (!this.selectedDateRange) ? null : (!this.selectedDateRange[1]) ? null :
                moment(this.selectedDateRange[1]).format('YYYY-MM-DDTHH:mm:ss'),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
        this.deliveryOrderService.getRiderDeliveryOrders(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.isOrderSpinner = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.totalEarningsStr = `₱${data.TotalEarnings}`;

                this.driverOrders = data.Items.map((x: any) => {
                    x.Id = x.Id;
                    x.DisplayFormatCreatedAt = moment(x.CreatedAt).format('DD/MM/YYYY | hh:mmA');
                    x.AmountText = `₱${x.Amount}`;
                    x.InitialTotalFareAmountText = `₱${x.InitialTotalFareAmount}`;
                    return x;
                });
                this.isOrderSpinner = false;
            })
            .catch(err => {
                this.isOrderSpinner = false;
                throw err;
            });
    }
    public uncheckServiceTypes() {
        this.selectedRiderVehicleTypes = [];
        this.changeDateRange();
    }

    public uncheckDeliveryStatuses() {
        this.selectedDeliveryStatuses = [];
        this.cancelRoleIds = [];
        this.changeDateRange();
    }

    public getRiderWalletInfo() {
        const dto = {
            RiderId: this.driverId
        };
        this.deliveryOrderService.getRiderWalletInfo(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.riderWallet = data;
				this.riderWallet.XpressWalletAmount = `₱ ${this.riderWallet.XpressWalletAmount ?? 0.00}`;
				this.riderWallet.CashWalletAmount = `₱ ${this.riderWallet.CashWalletAmount ?? 0.00}`;
				this.riderWallet.DriverSecurityDepositWalletAmount = `₱ ${this.riderWallet.DriverSecurityDepositWalletAmount ?? 0.00}`;
				this.riderWallet.BoundaryBondWalletAmount = `₱ ${this.riderWallet.BoundaryBondWalletAmount ?? 0.00}`;
            });

    }
    public menuFinanceTabChange(value: MenuFinanceTab) {
        this.activeMenuFinanceTab = value;

        if (this.activeMenuFinanceTab === MenuFinanceTab.Balance) {
            this.getRiderWalletInfo();
        }
        if (this.activeMenuFinanceTab === MenuFinanceTab.Payout) {
            this.getRiderInvoices(0);
        }
    }

    public getRiderTransactions() {
        const [startDate, endDate] = this.selectedDateRange || [];
        const dto = {
            RiderId: this.driverId,
            StartDate: startDate ? moment(startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            EndDate: endDate ? moment(endDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.riderService.getRiderTransactions(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.riderTransactions = data;
                this.riderTransactions = this.formatRiderTransactions(data.Items);
            });

    }

    formatRiderTransactions(riderTransactions: any): any {
        riderTransactions.map((x: any) => {
            x.CreatedAtStr = Utils.utcToFormatedLocalDateStrNoTime(x.CreatedAt);
        });
        return riderTransactions;
    }

    public getRiderInvoices(skip: number) {
        const dto = {
            UserId: this.riderWallet.XpressUserId,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
        this.riderService.getRiderInvoices(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }

                this.riderInvoices = data.Items.map((x: any) => {
                    x.InvoiceDate = moment(x.CreatedAt).format('DD/MM/YYYY | hh:mm A');
                    x.Amount = `₱ ${x.Amount}`;
                    return x;
                });
            });

    }

    public getHistoryRiderAvailabilities() {
        this.riderActivityHistory
            .loadAvailabilities(this.driverId, this.selectedDateRange?.[0], this.selectedDateRange?.[1], this.messageService)
            .then(rows => {
                this.riderHistories = rows;
            })
            .catch(err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || err });
            });
    }

    public getRiderLocationHistory() {
        this.riderActivityHistory
            .loadLocationHistory(this.driverId, this.selectedDateRange?.[0], this.selectedDateRange?.[1], this.messageService)
            .then(location => {
                this.riderPointHistory = {
                    RiderFullName: location.riderName,
                    RiderImageUrl: location.riderImage,
                    Points: location.points
                };
                this.displayAllRoutes();
            })
            .catch(err => {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.message || err });
            });
    }

    public displayAllRoutes(): void {
        this.polylineRoutes = [];

        if (!this.riderPointHistory) {
            console.error('No riderPointHistory available.');
            return;
        }

        try {

            this.displayRiderHistoryRouteInMap(this.riderPointHistory.RiderFullName, this.riderPointHistory.RiderImageUrl, this.riderPointHistory.Points);

            if (this.polylineRoutes.length > 0) {
                this.addNavigationControls(this.polylineRoutes);
            }
        } catch (error) {
            console.error('Error displaying routes:', error);
        }
    }

    public displayRiderHistoryRouteInMap(riderName: string, riderImage: string, points: any): void {
        const historyPoints = toRiderHistoryPoints(points);
        if (historyPoints.length === 0) {
            return;
        }
        if (!this.map) {
            this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
                zoom: 9,
                center: { lat: historyPoints[0].Lat, lng: historyPoints[0].Lng },
            });
        }

        if (historyPoints.length < 2) {
            console.warn('Not enough points to create a route.');
            return;
        }

        const drawn = drawRiderHistoryRouteOnMap(this.map, historyPoints, riderName, riderImage);
        this.polylineRoutes.push(drawn.polylineRoute);
    }


    addNavigationControls(routes: any[]): void {
        const currentRouteIndex = 0;
        let currentPointIndex = 0;
        let currentMarker: google.maps.Marker | null = null;

        const centerMapOnPoint = (routeIndex: number, pointIndex: number): void => {
            const route = routes[routeIndex];
            if (!route || !route.points || route.points.length === 0) {
                console.error(`Invalid route data for index ${routeIndex}`);
                return;
            }

            const point = route.points[pointIndex];
            if (!point) {
                console.error(`Invalid point data for index ${pointIndex}`);
                return;
            }

            const latLng = new google.maps.LatLng(point.Lat, point.Lng);
            this.map.setCenter(latLng);
            this.map.setZoom(17);

            if (currentMarker) {
                currentMarker.setMap(null);
            }

            currentMarker = new google.maps.Marker({
                position: latLng,
                map: this.map,
                icon: {
                    url: '/Content/xpress-app/images/svg/active-marker.svg', // Иконка активной точки
                    scaledSize: new google.maps.Size(18, 18),
                },
                title: `Point ${pointIndex + 1} of Route ${routeIndex + 1}`,
            });

            routes.forEach((r, i) => {
                if (r.routePath instanceof google.maps.Polyline) {
                    r.routePath.setOptions({
                        strokeColor: i === routeIndex ? '#1CBA70' : '#616161',
                        zIndex: i === routeIndex ? 2 : 1,
                    });
                }
            });
        };

        const controlsContainer = document.createElement('div');
        controlsContainer.style.position = 'absolute';
        controlsContainer.style.top = '45%';
        controlsContainer.style.width = '100%';
        controlsContainer.style.display = 'flex';
        controlsContainer.style.justifyContent = 'space-between';
        controlsContainer.style.pointerEvents = 'none';

        const prevButton = document.createElement('img');
        prevButton.src = '/Content/xpress-app/images/svg/chevron-left.svg';
        prevButton.style.pointerEvents = 'auto';
        prevButton.style.cursor = 'pointer';
        prevButton.style.marginLeft = '17px';
        prevButton.style.width = '40px';

        const nextButton = document.createElement('img');
        nextButton.src = '/Content/xpress-app/images/svg/chevron-right.svg';
        nextButton.style.pointerEvents = 'auto';
        nextButton.style.cursor = 'pointer';
        nextButton.style.marginRight = '60px';
        nextButton.style.width = '40px';

        prevButton.addEventListener('click', () => {
            currentPointIndex = (currentPointIndex - 1 + routes[currentRouteIndex].points.length) % routes[currentRouteIndex].points.length;
            centerMapOnPoint(currentRouteIndex, currentPointIndex);
        });

        nextButton.addEventListener('click', () => {
            currentPointIndex = (currentPointIndex + 1) % routes[currentRouteIndex].points.length;
            centerMapOnPoint(currentRouteIndex, currentPointIndex);
        });

        controlsContainer.appendChild(prevButton);
        controlsContainer.appendChild(nextButton);

        const mapDiv = document.getElementById('map');
        if (mapDiv) {
            mapDiv.style.position = 'relative';
            mapDiv.appendChild(controlsContainer);
        }

        centerMapOnPoint(0, 0);
    }

    public displayOrderHistoryRouteInMap(points: any, deliveryStatus: number, orderId: number, earnings: number): Promise<void> {
        if (!this.map) {
            this.map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
                zoom: 15,
                center: { lat: points[0].Lat, lng: points[0].Lng },
            });
        }

        const startPoint = { lat: points[0].Lat, lng: points[0].Lng };
        const endPoint = { lat: points[points.length - 1].Lat, lng: points[points.length - 1].Lng };

        const directionsService = new google.maps.DirectionsService();

        const waypoints = points.slice(1, -1).map((point: any) => ({
            location: new google.maps.LatLng(point.Lat, point.Lng),
            stopover: false,
        }));

        const request: google.maps.DirectionsRequest = {
            origin: new google.maps.LatLng(points[0].Lat, points[0].Lng),
            destination: new google.maps.LatLng(points[points.length - 1].Lat, points[points.length - 1].Lng),
            waypoints,
            travelMode: google.maps.TravelMode.DRIVING,
        };

        return new Promise((resolve, reject) => {
            directionsService.route(request, (result, status) => {
                if (status === google.maps.DirectionsStatus.OK && result) {
                    const orderStatus = (deliveryStatus === XpressDeliveryStatus.Completed) ? 'Completed'
                        : (deliveryStatus === XpressDeliveryStatus.Canceled) ? 'Canceled' : 'In process';

                    const bgColorStatus = (deliveryStatus === XpressDeliveryStatus.Completed) ? '#28a745'
                        : (deliveryStatus === XpressDeliveryStatus.Canceled) ? '#EB4236' : '#ffc107';

                    const infoWindow = new google.maps.InfoWindow({
                        content: `
                        <div style="font-size: 14px; color: #333;">
                            <p style="margin: 5px 0;">Booking ID: <span style="color: #333;">${orderId}</span></p>
                            ${deliveryStatus === XpressDeliveryStatus.Completed ? `<p style="margin: 5px 0;">Earnings: <span>₱${earnings.toFixed(2)}</span></p>` : ``}
                        <div style="
                            text-align: center; 
                            padding: 5px 10px; 
                            background-color: ${bgColorStatus}; 
                            color: white;
                            border-radius: 6px;
                            display: inline-block;
                            ">
                            ${orderStatus}
                        </div>
                        </div>
                        `,
                    });

                    const routePath = new google.maps.Polyline({
                        path: result.routes[0].overview_path,
                        geodesic: true,
                        strokeColor: '#1CBA70',
                        strokeOpacity: 1.0,
                        strokeWeight: 5,
                        map: this.map,
                    });

                    routePath.addListener('click', (event: any) => {
                        infoWindow.setPosition(event.latLng);
                        infoWindow.open(this.map);
                    });

                    this.polylineRoutes.push({
                        routePath,
                        points,
                        orderId,
                    });

                    new google.maps.Marker({
                        position: startPoint,
                        map: this.map,
                        icon: {
                            url: '/Content/xpress-app/images/svg/green-ellipse-marker.svg',
                            scaledSize: new google.maps.Size(13, 13),
                        },
                        title: `Start Point for Order ${orderId}`,
                    });

                    const endMarker = new google.maps.Marker({
                        position: endPoint,
                        map: this.map,
                        icon: {
                            url: '/Content/xpress-app/images/svg/green-ellipse-marker.svg',
                            scaledSize: new google.maps.Size(13, 13),
                        },
                        title: `End Point for Order ${orderId}`,
                    });

                    endMarker.addListener('click', () => {
                        infoWindow.open(this.map, endMarker);
                    });

                    resolve();
                } else {
                    console.error(`Directions request failed due to ${status}`);
                    reject(`Directions request failed due to ${status}`);
                }
            });
        });
    }

    public clickExportRiderAppHistory() {
        this.riderActivityHistory
            .exportAppHistory(this.driverId, this.selectedDateRange?.[0], this.selectedDateRange?.[1], this.messageService)
            .then(data => {
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Success' });
                Utils.saveFileResponse(data, 'Rider app history-' + new Date().valueOf() + '.csv');
            });
	}

	public getRiderShiftLogs(skip: number = 0) {
		this.isShiftLogSpinner = true;
		this.riderService.getRiderShiftLogs(
			{ RiderId: this.driverId, Skip: skip, Take: this.rowsPerPage, TimezoneOffset: Utils.getTimezoneOffset() },
			this.messageService
		)
			.then(data => {
				if (!data?.Success) {
					this.isShiftLogSpinner = false;
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage || 'Failed to load shift logs' });
					return;
				}
				this.totalShiftLogRecords = data.TotalRecords ?? 0;
				this.firstShiftLog = skip;
				this.riderShiftLogs = (data.Items || []).map((x: any) => ({
					...x,
					StartedAtDisplay: x.StartedAt ? moment(x.StartedAt).format('DD/MM/YYYY hh:mm A') : '',
					EndedAtDisplay: x.EndedAt ? moment(x.EndedAt).format('DD/MM/YYYY hh:mm A') : '—'
				}));
				this.isShiftLogSpinner = false;
			})
			.catch(() => {
				this.isShiftLogSpinner = false;
			});
	}

	public onShiftLogPage(event: any) {
		this.getRiderShiftLogs(event.first);
	}

	public endRiderShift(shiftLog: any) {
		this.confirmationDialogService.confirm('End shift?', 'Are you sure you want to end this shift?')
			.subscribe(confirmed => {
				if (confirmed) {
					this.doEndRiderShift(shiftLog);
				}
			});
	}

	private doEndRiderShift(shiftLog: any) {
		this.riderService.endRiderShift(
			{ ShiftId: shiftLog.Id, RiderId: this.driverId },
			this.messageService
		)
			.then(data => {
				if (!data?.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage || 'Failed to end shift' });
					return;
				}
				this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Shift ended successfully' });
				this.getRiderShiftLogs(this.firstShiftLog);
			});
	}

	public getUnsyncedOrders(skip: number = 0) {
		this.isUnsyncedSpinner = true;
		this.riderService.getUnsyncedOrders(
			{ XpressRiderId: this.driverId, Skip: skip, Take: this.rowsPerPage, TimezoneOffset: Utils.getTimezoneOffset() },
			this.messageService
		)
			.then(data => {
				if (!data?.Success) {
					this.isUnsyncedSpinner = false;
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage || 'Failed to load unsynced rides' });
					return;
				}
				this.totalUnsyncedRecords = data.TotalRecords ?? 0;
				this.totalUncollectedFare = data.TotalUncollectedFare ?? 0;
				this.totalFareAll = data.TotalFare ?? 0;
				this.firstUnsynced = skip;
				this.unsyncedOrders = (data.Items || []).map((x: any) => ({
					...x,
					StatusDisplay: x.Status === 1 ? 'Resolved' : 'Pending',
					ClientRefShort: x.ClientReferenceId ? (String(x.ClientReferenceId).substring(0, 8) + '…') : '',
					OrderIdDisplay: x.XpressDeliveryOrderId ? x.XpressDeliveryOrderId : '—',
					TotalFareDisplay: (x.TotalFare !== null && x.TotalFare !== undefined) ? Number(x.TotalFare).toFixed(2) : '—',
					CreatedAtDisplay: x.CreatedAt ? moment(x.CreatedAt).format('DD/MM/YYYY hh:mm A') : '',
					LastAttemptAtDisplay: x.LastAttemptAt ? moment(x.LastAttemptAt).format('DD/MM/YYYY hh:mm A') : '—'
				}));
				this.isUnsyncedSpinner = false;
			})
			.catch(() => {
				this.isUnsyncedSpinner = false;
			});
	}

	public onUnsyncedPage(event: any) {
		this.getUnsyncedOrders(event.first);
	}

	public syncUnsyncedOrder(row: any) {
		this.confirmationDialogService.confirm('Sync ride?', 'Sync this offline ride now?')
			.subscribe(confirmed => {
				if (confirmed) {
					this.doSyncUnsyncedOrder(row);
				}
			});
	}

	private doSyncUnsyncedOrder(row: any) {
		this.syncingId = row.Id;
		this.riderService.syncOfflineOrderFailure({ FailureId: row.Id }, this.messageService)
			.then(data => {
				if (!data?.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage || 'Failed to sync ride' });
					return;
				}
				const itemResult = (data.Results || [])[0];
				if (itemResult && !itemResult.Success) {
					this.messageService.add({ severity: 'warn', summary: 'Not synced', detail: itemResult.ErrorMessage || 'Sync failed' });
				} else {
					this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Ride synced successfully' });
				}
				this.getUnsyncedOrders(this.firstUnsynced);
			})
			.finally(() => {
				this.syncingId = null;
			});
	}

	public syncAllUnsyncedForRider() {
		this.confirmationDialogService.confirm('Sync all rides?', 'Sync all pending offline rides for this rider?')
			.subscribe(confirmed => {
				if (confirmed) {
					this.doSyncAllUnsyncedForRider();
				}
			});
	}

	private doSyncAllUnsyncedForRider() {
		this.isSyncingAll = true;
		this.riderService.syncOfflineOrderFailuresByRider({ XpressRiderId: this.driverId }, this.messageService)
			.then(data => {
				if (!data?.Success) {
					this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage || 'Failed to sync rides' });
					return;
				}
				this.messageService.add({
					severity: 'success',
					summary: 'Success',
					detail: `Processed ${data.TotalProcessed ?? 0}: ${data.SucceededCount ?? 0} synced, ${data.FailedCount ?? 0} failed`
				});
				this.getUnsyncedOrders(this.firstUnsynced);
			})
			.finally(() => {
				this.isSyncingAll = false;
			});
	}

    public getRiderTrainings(skip: number) {
        //TODO after specs available
        // this.driverTrainings = [
        //     { Date: moment(Utils.utcToLocalDate(new Date())).format('MM/DD/YY'), Type: 'Skills Assessment',
        //         Trainer: 'Teb Soriano', Assessor: 'Ferds Delin', Time: moment(Utils.utcToLocalDate(new Date())).format('hh:mm A'),
        //         Result: TrainingResultEnum.Passed, File: ''},
        //     { Date: moment(Utils.utcToLocalDate(new Date())).format('MM/DD/YY'), Type: 'Skills Assessment',
        //         Trainer: 'Teb Soriano', Assessor: 'Ferds Delin', Time: moment(Utils.utcToLocalDate(new Date())).format('hh:mm A'),
        //         Result: TrainingResultEnum.Failed, File: ''},
        // ]
    }

    cancel() {
        // const isBackToDashboard = sessionStorage.getItem('isOpenByDashboard');
        // if(isBackToDashboard === 'true'){
        //     sessionStorage.removeItem('isOpenByDashboard');
        //     const route = {
        //         root: RootEnum.OperatorDashboard,
        //         menuFlag: MenuHomeEnum.Application,
        //         label: MenuLabel.Dashboard,
        //         routerLink: MenuLinkEnum.OperatorDashboard,
        //         icon: MenuIcons.Audit,
        //         id: MenuPermissionConfig.OPERATOR_DASHBOARD,
        //         isRoot: true
        //     };
        //     this.routeObserverService.addRoute(route);
        // } else {
        // }
        this.isCommerceTab = false;
        this.changedVisibleDetail(!this.visibleDetail);
    }

    public handleTabChange(menuTab: MenuTab) {
        this.activeTab = menuTab;
        console.log(menuTab);

        if (this.activeTab === MenuTab.Vehicles) {
            this.getRiderVehicles();
        }
        else if (this.activeTab === MenuTab.LegalDocument) {
            this.onLegalDocumentTabOpen();
        }
        else if (this.activeTab === MenuTab.Finances) {
            this.getRiderWalletInfo();
            this.getRiderTransactions();
        }
        else if (this.activeTab === MenuTab.DriverStats) {
            this.getRiderStatistics();
        }
        else if (this.activeTab === MenuTab.History) {
            console.log('Call History');
            this.getHistoryRiderAvailabilities();
            this.getRiderLocationHistory();
        }
        else if (this.activeTab === MenuTab.Orders) {
            this.getRiderDeliveryOrders(0);
            this.getRiderStatistics();
        }
        else if (this.activeTab === MenuTab.Training) {
            this.getRiderTrainings(0);
		}
		else if (this.activeTab === MenuTab.RiderShiftLog) {
			this.getRiderShiftLogs(0);
		}
		else if (this.activeTab === MenuTab.OfflineSync) {
			this.getUnsyncedOrders(0);
		}
    }

    public changeDateRange() {
        this.handleTabChange(this.activeTab);
    }

    public openSidebarDisplayOrderDetail(item: any) {
        this.orderId = item.Id;
        this.isVisibleDisplayOrderDetail = true;
    }
    changedVisibleDisplayOrderDetailEmit(value: any) {
        this.isVisibleDisplayOrderDetail = value;
    }

    public openSidebarDriverTransactionDetail(item: any) {
        this.transactionDetail = item;
        this.isVisibleDriverTransactionDetail = true;
    }
    changedVisibleDriverTransactionDetailEmit(value: any) {
        this.isVisibleDriverTransactionDetail = value;
    }

    public ownerVehicleDetailData: any = {};
    changedVisibleDisplayVehicleOwnerDetailEmit(value: any, vehicle: any) {
        this.isVisibleOwnerInfoDetail = value;
        this.ownerVehicleDetailData.vehicle = vehicle;
    }

    public getRiderStatistics() {
        const [startDate, endDate] = this.selectedDateRange || [];

        const dto = {
            RiderId: this.driverId,
            StartDate: startDate ? moment(startDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            EndDate: endDate ? moment(endDate).format('YYYY-MM-DDTHH:mm:ss') : null,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.riderService.getRiderStatistics(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.riderStatistics = data;
                this.riderStatistics.ColumnColors = [];
                for (let i = 0; i <= this.riderStatistics.ActiveHoursStat.length; i++) {
                    this.riderStatistics.ColumnColors.push('#004060');
                }

                this.riderStatistics.RiderRatingRounded = Math.floor(data.RiderRating);
                this.riderStatistics.CustomerNotes = this.riderStatistics.CustomerNotes.map((x: any) => {
					x.CreatedAt = moment(Utils.utcToLocalDate(x.CreatedAt)).format('DD MMM YYYY');
                    return x;
                });
                this.riderStatistics.HoursOnline = Math.round(this.riderStatistics.HoursOnline * 10) / 10;

                for (let i = 0; i <= 4; i++) {
                    this.ratingPercentages[i + 1] = data.CountMarks !== 0 ? Math.round((this.riderStatistics.Marks[i].Count / data.CountMarks) * 100) : 0;
                }
                for (let i = 0; i < data.CustomerFeedback.length; i++) {
                    this.customerFeedbackPercents[this.riderStatistics.CustomerFeedback[i].DriverAwardId] = data.CompletedJobsPerPeriod !== 0 ?
                        Math.round((this.riderStatistics.CustomerFeedback[i].Count / data.CompletedJobsPerPeriod) * 100) : 0;
                }
                this.activeHoursChartInit();
            });

    }

    public handleAllCommentsChange() {
        this.showAllComments = !this.showAllComments;
    }

    public getMaskedReviewNote(note: string | null | undefined): string {
        if (!note) {
            return '';
        }
        if (!this.isOperator) {
            return note;
        }
        // Operators must not see free-text review content that may include customer PII.
        return '••••••••';
    }

    notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
        return value !== null && value !== undefined && value !== '';
    }

    public isVisibleOwnerInfoDetail: boolean = false;
    changeVisibleOwnerInfo() {
        this.isVisibleOwnerInfoDetail = !this.isVisibleOwnerInfoDetail;
    }

    updateCarouselImages() {
        this.initIdentifDocsImages();
        this.initVehicleDocsImages();
        this.initTNVSDocsImgs();
        this.buildLegalDocumentCards();
    }

    public showVisibleImageModal(images: string[], isPdfFile: boolean) {
        this.imageArray = images;
        this.isVisibleImageModal = true;
        this.isPdfFile = isPdfFile;
    }

    public handleInputProfileImgClick(id: string): void {
        document.getElementById(id)?.click();
    }
    public handleInputProfileImgChange(event: Event) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.driver.ImageUrl = e.target.result.toString();
                this.driver.ImageData = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    public handleInputTrainingFileClick(id: string): void {
        document.getElementById(id)?.click();
    }
    public handleInputTrainingFileChange(event: Event, index: number) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 2MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                //this.driverTrainings[index].FileData = e.target.result.toString(); //todo after specs available
            }
        };

        reader.readAsDataURL(file);
    }

    public showModalSuspend(user: any) {
        this.suspendUser = {
            userId: user.XpressUserId,
            userName: user.UserName
        };

        this.displayModalSuspend = !this.displayModalSuspend;
    }
    changedDisplayModalSuspendEmit(value: any) {
        this.displayModalSuspend = value;
    }

    public openAddOrUpdateDisciplinarySideBar() {
        this.showAddOrUpdateDisciplinarySideBar = true;
    }
    changedShowAddOrUpdateDisciplinarySideBarEmit(value: any) {
        this.showAddOrUpdateDisciplinarySideBar = value;
    }

    public openDriverPayoutInvoiceSideBar(id: number) {
        this.invoiceId = id;
        this.isVisibleDisplayDriverPayoutInvoice = true;
    }
    changedVisibleDisplayDriverPayoutInvoiceEmit(value: any) {
        this.isVisibleDisplayDriverPayoutInvoice = value;
    }

    getServiceTypeImg(serviceType: ServiceTypeEnum) {
        switch (serviceType) {
            case ServiceTypeEnum.Ride: {
                return '/XpressApp/assets/images/car-red.svg';
            }
            case ServiceTypeEnum.Delivery: {
                return '/XpressApp/assets/images/delivery.svg';
            }
            case ServiceTypeEnum.Food: {
                return '/XpressApp/assets/images/food.svg';
            }
            case ServiceTypeEnum.Grocery: {
                return '/XpressApp/assets/images/grocery.svg';
            }
            case ServiceTypeEnum.Hire: {
                return '/XpressApp/assets/images/hire.svg';
            }
            default: {
                return '';
            }
        }
    }

    public resetXpressUserPassword() {
        const dto = {
            XpressUserId: this.driver.XpressUserId
        };
        this.resetPasswordLoading = true;
        this.userService.resetUserPassword(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    this.resetPasswordLoading = false;
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Password was sent via SMS' });
                this.resetPasswordLoading = false;
            })
            .catch(err => {
                this.resetPasswordLoading = false;
                throw err;
            });
    }

    public updateLegalDocuments() {
        const payload: { RiderId: number; PaOrCpcCaseNumber?: string } = {
            RiderId: this.driverId
        };

        if (this.uploadLegalDocumentsObj.PaOrCpcCaseNumber) {
            payload.PaOrCpcCaseNumber = this.uploadLegalDocumentsObj.PaOrCpcCaseNumber;
        }

        this.riderService.updateLegalDocuments(payload, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Documents updated' });
                this.uploadLegalDocumentsObj = {};
                this.getRiderInfo();
                this.showEditLegalDocuments = false;
            });

    }

    public handleImageClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event, imageName: string) {
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 5MB
        if (file.size > 5242880) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'This file is bigger than 5MB.' });
            return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                const imgBase64 = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
    }

    isPdf(url: string): Promise<boolean> {
        if (url) {
            const dto = {
                Url: url
            };

            return this.riderService.getContentTypeByImageUrl(dto, this.messageService)
                .then(data => {
                    if (!data.Success) {
                        console.log(data.ErrorMessage);
                        return false;
                    }

                    if (data.ContentType?.toLowerCase().includes('application/pdf')) {
                        return true;
                    } else {
                        return false;
                    }
                })
                .catch(err => {
                    console.log(err);
                    return false;
                });
        }
        return Promise.resolve(false);
    }

    getSafeUrl(url: string) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(url);
    }

    showPopupRefundTransaction() {
        if (!this.isAdjustWalletBalanceInFlight) {
            this.isRefundButtonDisabled = false;
            this.isRefundApplyButtonDisabled = false;
            this.adjustWalletBalanceIdempotencyKey = Utils.newIdempotencyKey();
        }

        this.showDialogRefundTransaction = true;
    }

    refundTransactionCancel() {
        this.showDialogRefundTransaction = false;
    }

    adjustTransactionApply() {
        if (this.isAdjustWalletBalanceInFlight || this.isRefundApplyButtonDisabled) {
            return;
        }

        this.isAdjustWalletBalanceInFlight = true;
        this.isRefundButtonDisabled = true;
        this.isRefundApplyButtonDisabled = true;
        const dto = {
            UserId: this.riderWallet?.XpressUserId,
            Amount: this.adjustWalletBalanceAmount,
            AdjustWalletBalanceType: this.selectedAdjustWalletBalanceType?.Id,
            Description: this.adjustWalletBalanceDescription
        };
        this.paymentProcessingService.adjustRiderWalletBalance(dto, this.messageService, this.adjustWalletBalanceIdempotencyKey)
            .then(data => {
                this.isAdjustWalletBalanceInFlight = false;
                if (!data?.Success) {
                    this.adjustWalletBalanceIdempotencyKey = Utils.newIdempotencyKey();
                    this.isRefundButtonDisabled = false;
                    this.isRefundApplyButtonDisabled = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data?.ErrorMessage ?? 'Failed to adjust wallet balance' });
                    return;
                }
                this.showDialogRefundTransaction = false;
                this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Adjusted Wallet Balance' });
                this.getRiderWalletInfo();
                this.getRiderTransactions();
            })
            .catch(err => {
                this.isAdjustWalletBalanceInFlight = false;
                this.isRefundButtonDisabled = false;
                this.isRefundApplyButtonDisabled = false;
                throw err;
            });
    }

    checkBetaFeatures(): boolean {
        return this.appData.authData.BetaFeatures.includes(BetaFeature.ADJUST_WALLET);
    }

    checkValidation() {
        this.isValidAmount =
            this.adjustWalletBalanceAmount !== null &&
            this.adjustWalletBalanceAmount !== undefined &&
            this.adjustWalletBalanceAmount !== 0;
        this.isPositiveAmountRequired =
            (this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.RxpGuaranteePay ||
                this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.AdminAdjustmentNineNine15KTopUp ||
                this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.AdminAdjustment4KTopUp) &&
            this.adjustWalletBalanceAmount <= 0;
        this.isNegativeAmountRequired =
            (this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.RxpDailyDeduction ||
                this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.RxpOperatorsDailyDeduction ||
                this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.GadgetDeductionInstallment ||
                this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.GadgetDeductionRegular ||
                this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.VehicleDeductionInstallment ||
                this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.VehicleDeductionRegular)
            &&
            this.adjustWalletBalanceAmount >= 0;
        this.isDescriptionRequired =
            this.selectedAdjustWalletBalanceType?.Id === AdjustWalletBalanceTypeEnum.GeneralAdjustment
            && !this.adjustWalletBalanceDescription?.trim();
    }

    openDriverUploadDoc() {
        this.visibleDriverUploadDoc = true;
    }
    changedVisibleDriverUploadDocEmit(value: boolean) {
        this.visibleDriverUploadDoc = value;
        this.getRiderInfo();
    }

	isSomeDocsExpiring() {
		const driverProfessionalLicenceExpiry = this.isDocExpired(this.driverLicenseExpirationDate) ||
			this.isDocExpiring(this.driverLicenseExpirationDate);

		const driverNBIClearanceExpiryAt = this.isDocExpired(this.nbiExpirationDate) ||
			this.isDocExpiring(this.nbiExpirationDate);

		const lTOOfficialReceiptExpireAt = this.isDocExpired(this.orCrExpirationDate) ||
			this.isDocExpiring(this.orCrExpirationDate);

		if (this.driver.VehicleTypeId !== RiderVehicleTypeEnum.Moto && this.driver.UseAnotherRidesharingApp) {
			const paOrCpcExpireAt = this.isDocExpired(this.paCpcExpirationDate) ||
				this.isDocExpiring(this.paCpcExpirationDate);

			return driverProfessionalLicenceExpiry || driverNBIClearanceExpiryAt
				|| lTOOfficialReceiptExpireAt || paOrCpcExpireAt;
		}

        return driverProfessionalLicenceExpiry || driverNBIClearanceExpiryAt
			|| lTOOfficialReceiptExpireAt;
    }

    onShowTransactions(){
        this.showTransactions.emit(this.driverId);
    }

    onShowDetails(event: number){
        this.showDetails.emit(event);
    }

    protected readonly RateType = RateType;
    protected readonly XpressUserRoleEnum = XpressUserRoleEnum;
    protected readonly RiderVehicleTypeEnum = RiderVehicleTypeEnum;
    protected readonly moment = moment;
    protected readonly XpressCalendarEnum = XpressCalendarEnum;
    protected readonly Utils = Utils;
    protected readonly ExportFileTypeModel = ExportFileTypeModel;
    protected readonly DriverCampaignType = DriverCampaignType;
}

export enum DriverDetailOrderStatusEnum {
    Completed = 'Completed',
    Cancelled = 'Cancelled',
    DriverCancelled = 'Driver Cancelled',
    CustomerCancelled = 'Customer Cancelled',
    AdminCancelled = 'Admin Cancelled',
    Rejected = 'Rejected',
}

export enum PartnerEnum {
    Bronze = 'Bronze',
    Silver = 'Silver',
    Gold = 'Gold',
}

export enum RateType {
    Completion = 1,
    Acceptance = 2,
    Cancellation = 3
}

export enum PerformanceRate {
    Good = 'good',
    Medium = 'medium',
    Bad = 'bad',
    None = ''
}

export enum TrainingResultEnum {
    Passed = 'Passed',
    Failed = 'Failed',
}
